import * as tslib_1 from "tslib";
// Core packages
import { ElementRef, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";
// import { User } from "src/app/shared/models/user/user.model";
import { AuthService } from "src/app/modules/auth/auth.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { Property } from "src/app/shared/models/property/property.model";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { Company } from 'src/app/shared/models/company/company.model';
import { ApiService } from "src/app/shared/services/api.service";
import { DocumentDownloadDialogComponent } from '../../components/document-download-dialog/document-download-dialog.component';
import { CondoStructuresService } from "../../condo-structures.service";
import { DocumentArchivesService } from "../../document-archives.service";
import DocumentTypeStructure from "../../documentTypes";
var ViewPropertyComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function ViewPropertyComponent(configService, activatedRoute, propertiesService, router, toastrService, helperService, translateService, themeService, authService, dialog, cookieService, companiesService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    // private rolesService: RolesService,
    // private subscriptionsService: SubscriptionsService,
    // private userService: UsersService,
    condoStructuresService, documentArchivesService, settingsService) {
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.propertiesService = propertiesService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.dialog = dialog;
        this.cookieService = cookieService;
        this.companiesService = companiesService;
        this.apiService = apiService;
        this.condoStructuresService = condoStructuresService;
        this.documentArchivesService = documentArchivesService;
        this.settingsService = settingsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // Could not be "Property" type because in "get" method in the back-end
        // We are populating some fields, so the model is not the same!
        this.property = new Property();
        this.detailCardIsLoading = true;
        this.deleteCardIsLoading = true;
        this.sharedUserCardIsLoading = true;
        this.companyAdmin = "";
        this.companyOwner = "";
        this.address = "";
        this.propertyId = "";
        this.company = new Company();
        this.documentArchiveIsLoading = true;
        this.pageIsLoading = true;
        this.structureIsLoading = true;
        this.condoStructureOpen = true;
        this.insertedDocs = [];
        this.allDocs = [];
        this.documentsStructure = [];
        this.displayedDocs = [];
        this.mappingIndex = [];
        // BEGIN - Formly config
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {
            formState: {
                disabled: false
            }
        };
        // END - Formly config
        this.formIsLoading = false;
        this.sectionPlant = false;
        this.formActiveSubitemId = "";
        this.formActiveSection = "";
        this.totMandatoryDocs = 0;
        this.totInsertDocs = 0;
        this.totNotInsertDocs = 0;
        this.totOptionalDocs = 0;
        this.totDocs = 0;
        this.subscriptionType = "FREE";
        this.documentTypeStructure = new DocumentTypeStructure();
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.condoStructureTemplateId = "";
        this.condoStructureTemplate = [];
        this.originalOrder = function (a, b) {
            return 0;
        };
        // @OLD
        // // Translate some string inside mappingIndex before formly get intialized
        // this.mappingIndex = this.translateKeys(
        //   ["placeholder", "label"],
        //   this.mappingIndex
        // );
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("properties.detail.pageTitle"));
        this.subscriptions.push(this.settingsService.getStructure().subscribe(function (res) {
            if (res.status) {
                if (res.condoStructureTemplate &&
                    Array.isArray(res.condoStructureTemplate) &&
                    res.condoStructureTemplate.length > 0 &&
                    res.condoStructureTemplate[0].area &&
                    Array.isArray(res.condoStructureTemplate[0].area)) {
                    _this.condoStructureTemplateId = res.condoStructureTemplate[0]._id;
                    _this.condoStructureTemplate = res.condoStructureTemplate[0].area;
                    _this.mappingIndex = _this.condoStructureTemplate;
                    _this.mappingIndex = _this.translateKeys2(["placeholder", "label"], _this.mappingIndex);
                }
            }
        }));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get logged user's role data
        this.currentRole = this.loggedUser.userRoles.find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        if (!this.currentRole.propertiesPermission) {
            this.currentRole.propertiesPermission = {
                amiantoDoc: false,
                amminImmobile: false,
                antincendio: false,
                ascensori: false,
                contratti: false,
                edile: false,
                expiresUnlimited: false,
                gestionaleAmministrativo: false,
                impiantoElettrico: false,
                impiantiElettronici: false,
                impiantiRicreativiSportivi: false,
                impiantiSpeciali: false,
                lineaVita: false,
                mappatura: false,
                riscaldamentoCondizionamento: false,
                trattamentoAcqua: false,
                unitaImmobiliari: false,
                unlimited: false,
                gestionaleContabile: false,
                urbanisticaEdEdilizia: false,
                catasto: false,
                preventivi: false,
            };
        }
        // Get current lang
        this.lang = this.cookieService.get("lang") || this.configService.defaultLang;
    };
    /**
       * After view init logic
       *
       * @since 1.0.0
       */
    ViewPropertyComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.currentRole.type == "shared") {
            // Get Property
            if (this.currentRole.propertiesPermission) {
                // Get requested property data
                this.propertyId = this.currentRole.propertiesPermission.property[0];
                // Get requested property data, company data and document archive
                this.subscriptions.push(this.propertiesService.get(this.propertyId).subscribe(function (res) {
                    if (res.status) {
                        _this.property.setData(res.data);
                        _this.propertyData = res.data;
                        if (_this.propertyData &&
                            _this.propertyData.subscription &&
                            _this.propertyData.subscription.key) {
                            _this.subscriptionType = _this.propertyData.subscription.key;
                        }
                        if (_this.propertyData.admin
                            && _this.propertyData.admin.company
                            && _this.propertyData.admin.company._id) {
                            _this.subscriptions.push(_this.companiesService.get(_this.propertyData.admin.company._id).subscribe(function (res) {
                                if (res.status) {
                                    _this.company.setData(res.data);
                                    _this.companyAdmin = _this.company.get("name");
                                }
                            }));
                        }
                        _this.companyOwner = "";
                        if (_this.propertyData.owner) {
                            _this.subscriptions.push(_this.companiesService.get(_this.propertyData.owner).subscribe(function (res) {
                                if (res.status) {
                                    _this.company.setData(res.data);
                                    _this.companyOwner = _this.company.get("name");
                                }
                            }));
                        }
                        if (_this.propertyData.address) {
                            _this.address = _this.propertyData.address.route + ",\n                  " + _this.propertyData.address.streetNumber + " -\n                  " + _this.propertyData.address.postalCode + "\n                  " + _this.propertyData.address.city;
                        }
                        // If property has a structure ID, than retrive related data
                        // and document archive
                        if (_this.propertyData.structure) {
                            _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                                if (res.status) {
                                    if (res.data &&
                                        Array.isArray(res.data) &&
                                        res.data.length > 0 &&
                                        res.data[0].area &&
                                        Array.isArray(res.data[0].area)) {
                                        _this.documentTemplateId = res.data[0]._id;
                                        _this.documentTemplate = res.data[0].area;
                                        _this.documentsStructure = _this.documentTemplate.map(function (elDT) {
                                            var subEl = [];
                                            if (Array.isArray(elDT.content)) {
                                                subEl = elDT.content.map(function (subElDT) {
                                                    return {
                                                        title: subElDT.title,
                                                        translation: subElDT.translation,
                                                        type: subElDT.type,
                                                        expanded: subElDT.expanded,
                                                        section: subElDT.section,
                                                        visible: subElDT.visible,
                                                        key: subElDT.key,
                                                    };
                                                });
                                            }
                                            return {
                                                title: elDT.title,
                                                translation: elDT.translation,
                                                type: elDT.type,
                                                section: "",
                                                buttonTitle: "",
                                                expanded: elDT.expanded,
                                                icon: "",
                                                visible: elDT.visible,
                                                content: subEl,
                                            };
                                        });
                                        // Hide all visible elements of side menu
                                        for (var key in _this.documentsStructure) {
                                            _this.documentsStructure[key].visible = false;
                                            if (Array.isArray(_this.documentsStructure[key].content)) {
                                                _this.documentsStructure[key].content.forEach(function (el) {
                                                    el.visible = false;
                                                });
                                            }
                                        }
                                        _this.getStructureData();
                                    }
                                }
                            }, function (err) {
                                //
                            }));
                        }
                        else {
                            _this.documentArchiveIsLoading = false;
                        }
                        _this.pageIsLoading = false;
                        return;
                    }
                    // Something bad happened
                    // redirect user to home
                    _this.router.navigate([_this.lang, "app", "properties", "list"]);
                }, function (err) {
                    // if we came here users with given userId do not exist
                    _this.router.navigate([_this.lang, "errors", "404"]);
                }));
            }
        }
        else if (this.currentRole.type == "temporary") {
            // Get Property
            if (this.currentRole.propertiesPermission) {
                // Get requested property data
                this.propertyId = this.activatedRoute.snapshot.params.propertyId;
                // Get requested property data, company data and document archive
                this.subscriptions.push(this.propertiesService.get(this.propertyId).subscribe(function (res) {
                    if (res.status) {
                        _this.property.setData(res.data);
                        _this.propertyData = res.data;
                        if (_this.propertyData &&
                            _this.propertyData.subscription &&
                            _this.propertyData.subscription.key) {
                            _this.subscriptionType = _this.propertyData.subscription.key;
                        }
                        if (_this.propertyData.admin
                            && _this.propertyData.admin.company
                            && _this.propertyData.admin.company._id) {
                            _this.subscriptions.push(_this.companiesService.get(_this.propertyData.admin.company._id).subscribe(function (res) {
                                if (res.status) {
                                    _this.company.setData(res.data);
                                    _this.companyAdmin = _this.company.get("name");
                                }
                            }));
                        }
                        _this.companyOwner = "";
                        if (_this.propertyData.owner) {
                            _this.subscriptions.push(_this.companiesService.get(_this.propertyData.owner).subscribe(function (res) {
                                if (res.status) {
                                    _this.company.setData(res.data);
                                    _this.companyOwner = _this.company.get("name");
                                }
                            }));
                        }
                        if (_this.propertyData.address) {
                            _this.address = _this.propertyData.address.route + ",\n                  " + _this.propertyData.address.streetNumber + " -\n                  " + _this.propertyData.address.postalCode + "\n                  " + _this.propertyData.address.city;
                        }
                        // If property has a structure ID, than retrive related data
                        // and document archive
                        if (_this.propertyData.structure) {
                            _this.subscriptions.push(_this.settingsService.getDocument().subscribe(function (res) {
                                if (res.status) {
                                    if (res.data &&
                                        Array.isArray(res.data) &&
                                        res.data.length > 0 &&
                                        res.data[0].area &&
                                        Array.isArray(res.data[0].area)) {
                                        _this.documentTemplateId = res.data[0]._id;
                                        _this.documentTemplate = res.data[0].area;
                                        _this.documentsStructure = _this.documentTemplate.map(function (elDT) {
                                            var subEl = [];
                                            if (Array.isArray(elDT.content)) {
                                                subEl = elDT.content.map(function (subElDT) {
                                                    return {
                                                        title: subElDT.title,
                                                        translation: subElDT.translation,
                                                        type: subElDT.type,
                                                        expanded: subElDT.expanded,
                                                        section: subElDT.section,
                                                        visible: subElDT.visible,
                                                        key: subElDT.key,
                                                    };
                                                });
                                            }
                                            return {
                                                title: elDT.title,
                                                translation: elDT.translation,
                                                type: elDT.type,
                                                section: "",
                                                buttonTitle: "",
                                                expanded: elDT.expanded,
                                                icon: "",
                                                visible: elDT.visible,
                                                content: subEl,
                                            };
                                        });
                                        // Hide all visible elements of side menu
                                        for (var key in _this.documentsStructure) {
                                            _this.documentsStructure[key].visible = false;
                                            if (Array.isArray(_this.documentsStructure[key].content)) {
                                                _this.documentsStructure[key].content.forEach(function (el) {
                                                    el.visible = false;
                                                });
                                            }
                                        }
                                        _this.getStructureData();
                                    }
                                }
                            }, function (err) {
                                //
                            }));
                        }
                        else {
                            _this.documentArchiveIsLoading = false;
                        }
                        _this.pageIsLoading = false;
                        return;
                    }
                    // Something bad happened
                    // redirect user to home
                    _this.router.navigate([_this.lang, "app", "properties", "list"]);
                }, function (err) {
                    // if we came here users with given userId do not exist
                    _this.router.navigate([_this.lang, "errors", "404"]);
                }));
            }
        }
    };
    /**
     * Get courrent property structure data and populate
     * this.condoStructure.
     * Then get archive document.
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.getStructureData = function () {
        var _this = this;
        this.condoStructuresService
            .get(this.property.get("structure"))
            .subscribe(function (res) {
            if (res.status) {
                _this.condoStructure = res.data;
                if (_this.condoStructure && !_this.condoStructure.open) {
                    _this.condoStructureOpen = false;
                }
                _this.structureIsLoading = false;
                // If property has a document Archive ID, than retrive related data
                if (_this.propertyData.documentArchive) {
                    _this.documentArchiveId = _this.propertyData.documentArchive;
                    _this.getDocumentArchiveData2();
                    _this.pageIsLoading = false;
                }
            }
            else {
                _this.documentArchiveIsLoading = false;
                _this.structureIsLoading = false;
                _this.toastrService.error(res.message);
            }
        });
    };
    /**
     * Get current property documentArchive data and populate
     * this.documentArchive
     * this.allDocs is used to show all docs in page
     *
     * @since 1.0.0
     */
    /**
     * Get current property documentArchive data and populate
     * this.documentArchive
     * this.allDocs is used to show all docs in page
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.getDocumentArchiveData = function () {
        var _this = this;
        this.documentArchiveIsLoading = true;
        this.insertedDocs = [];
        this.documentArchivesService
            .get(this.property.get("documentArchive"))
            .subscribe(function (res) {
            if (res.status) {
                _this.documentArchive = res.data;
                // Costruisco l'oggetto di tutti i documenti inseriti in archivio
                //
                // GESTIONALE AMMINISTRATIVO
                //
                if ((typeof res.data.gestAmmTivoGestionali !== 'undefined'
                    || res.data.gestAmmTivoDipendenti.length
                    || typeof res.data.gestAmmTivoGestioneDipend !== 'undefined'
                    || typeof res.data.gestAmmTivoGestioneRifiut !== 'undefined'
                    || typeof res.data.gestAmmTivoBanca !== 'undefined'
                    || typeof res.data.gestAmmTivoCauseLegali !== 'undefined'
                    || typeof res.data.gestAmmTivoSicurezza !== 'undefined'
                    || typeof res.data.gestAmmTivoAssicurazioni !== 'undefined'
                    || typeof res.data.gestAmmTivoValutFornitori !== 'undefined'
                    || typeof res.data.gestAmmTivoattoDiAcqven !== 'undefined'
                    || typeof res.data.gestAmmTivovincoliEDiri !== 'undefined'
                    || typeof res.data.gestAmmTivoipoteche !== 'undefined'
                    || typeof res.data.gestAmmTivotitolarita !== 'undefined'
                    || typeof res.data.gestAmmelaboratiGrafici !== 'undefined'
                    || typeof res.data.gestAmmApe !== 'undefined')
                    && _this.currentRole.propertiesPermission.gestionaleAmministrativo) {
                    var contents = [];
                    if (typeof res.data.gestAmmTivoGestionali !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoGestionali);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoGestionali"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoGestionali",
                            type: "doc",
                            content: items
                        });
                    }
                    if (res.data.gestAmmTivoDipendenti.length) {
                        var items = res.data.gestAmmTivoDipendenti.map(function (elem) {
                            var structureName = _this.condoStructure.dipendenti
                                ? _this.condoStructure.dipendenti.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome + " " + structureName.cognome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoDipendenti"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoDipendenti",
                            type: "title",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivoGestioneDipend !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoGestioneDipend);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoGestioneDipend"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoGestioneDipend",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivoGestioneRifiut !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoGestioneRifiut);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoGestioneRifiut"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoGestioneRifiut",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivoBanca !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoBanca);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoBanca"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoBanca",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivoCauseLegali !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoCauseLegali);
                        var items2_1 = [];
                        items.forEach(function (elem) {
                            var index = items2_1.findIndex(function (subElem) {
                                return subElem.title === elem.data.nomeArchiviazioneIntervento;
                            });
                            if (index > -1) {
                                items2_1[index].content.push(elem);
                            }
                            else {
                                items2_1.push({
                                    title: elem.data.nomeArchiviazioneIntervento,
                                    active: true,
                                    type: "title",
                                    docId: undefined,
                                    structureId: "",
                                    content: [elem]
                                });
                            }
                        });
                        if (items2_1.length) {
                            contents.push({
                                title: _this.translateService.instant("properties.documents.gestAmmTivoCauseLegali"),
                                keyTranslateTitle: "properties.documents.gestAmmTivoCauseLegali",
                                type: "title",
                                content: items2_1
                            });
                        }
                    }
                    if (typeof res.data.gestAmmTivoSicurezza !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoSicurezza);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoSicurezza"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoSicurezza",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivoAssicurazioni !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoAssicurazioni);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoAssicurazioni"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoAssicurazioni",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivoValutFornitori !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoValutFornitori);
                        var items2_2 = [];
                        items.forEach(function (elem) {
                            var index = items2_2.findIndex(function (subElem) {
                                return subElem.title === elem.data.nomeFornitore;
                            });
                            if (index > -1) {
                                items2_2[index].content.push(elem);
                            }
                            else {
                                items2_2.push({
                                    title: elem.data.nomeFornitore,
                                    active: true,
                                    type: "title",
                                    docId: undefined,
                                    structureId: "",
                                    content: [elem]
                                });
                            }
                        });
                        if (items2_2.length) {
                            contents.push({
                                title: _this.translateService.instant("properties.documents.gestAmmTivoValutFornitori"),
                                keyTranslateTitle: "properties.documents.gestAmmTivoValutFornitori",
                                type: "title",
                                content: items2_2
                            });
                        }
                    }
                    // EX GESTIONALE AMMINISTRATIVI IMMOBILE
                    if (typeof res.data.gestAmmTivoattoDiAcqven !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoattoDiAcqven);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoattoDiAcqven"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoattoDiAcqven",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivovincoliEDiri !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivovincoliEDiri);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivovincoliEDiri"),
                            keyTranslateTitle: "properties.documents.gestAmmTivovincoliEDiri",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivoipoteche !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivoipoteche);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivoipoteche"),
                            keyTranslateTitle: "properties.documents.gestAmmTivoipoteche",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmTivotitolarita !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmTivotitolarita);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmTivotitolarita"),
                            keyTranslateTitle: "properties.documents.gestAmmTivotitolarita",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmelaboratiGrafici !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmelaboratiGrafici);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmelaboratiGrafici"),
                            keyTranslateTitle: "properties.documents.gestAmmelaboratiGrafici",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.gestAmmApe !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.gestAmmApe);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.gestAmmApe"),
                            keyTranslateTitle: "properties.documents.gestAmmApe",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.gestionaleAmministrativo",
                        title: _this.translateService.instant("properties.documents.gestionaleAmministrativo"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // GESTIONALE AMMINISTRATIVI IMMOBILE
                //
                // if (typeof res.data.gestAmmTivoattoDiAcqven !== 'undefined'
                //   || typeof res.data.gestAmmTivovincoliEDiri !== 'undefined'
                //   || typeof res.data.gestAmmTivoipoteche !== 'undefined'
                //   || typeof res.data.gestAmmTivotitolarita !== 'undefined'
                //   || typeof res.data.gestAmmelaboratiGrafici !== 'undefined'
                //   || typeof res.data.gestAmmApe !== 'undefined') {
                //   const contents = [];
                //   if (typeof res.data.gestAmmTivoattoDiAcqven !== 'undefined') {
                //     const items = this.getDocsFromSection(res.data.gestAmmTivoattoDiAcqven);
                //     contents.push({
                //       title: this.translateService.instant("properties.documents.gestAmmTivoattoDiAcqven"),
                //       keyTranslateTitle: "properties.documents.gestAmmTivoattoDiAcqven",
                //       type: "doc",
                //       content: items
                //     });
                //   }
                //   if (typeof res.data.gestAmmTivovincoliEDiri !== 'undefined') {
                //     const items = this.getDocsFromSection(res.data.gestAmmTivovincoliEDiri);
                //     contents.push({
                //       title: this.translateService.instant("properties.documents.gestAmmTivovincoliEDiri"),
                //       keyTranslateTitle: "properties.documents.gestAmmTivovincoliEDiri",
                //       type: "doc",
                //       content: items
                //     });
                //   }
                //   if (typeof res.data.gestAmmTivoipoteche !== 'undefined') {
                //     const items = this.getDocsFromSection(res.data.gestAmmTivoipoteche);
                //     contents.push({
                //       title: this.translateService.instant("properties.documents.gestAmmTivoipoteche"),
                //       keyTranslateTitle: "properties.documents.gestAmmTivoipoteche",
                //       type: "doc",
                //       content: items
                //     });
                //   }
                //   if (typeof res.data.gestAmmTivotitolarita !== 'undefined') {
                //     const items = this.getDocsFromSection(res.data.gestAmmTivotitolarita);
                //     contents.push({
                //       title: this.translateService.instant("properties.documents.gestAmmTivotitolarita"),
                //       keyTranslateTitle: "properties.documents.gestAmmTivotitolarita",
                //       type: "doc",
                //       content: items
                //     });
                //   }
                //   if (typeof res.data.gestAmmelaboratiGrafici !== 'undefined') {
                //     const items = this.getDocsFromSection(res.data.gestAmmelaboratiGrafici);
                //     contents.push({
                //       title: this.translateService.instant("properties.documents.gestAmmelaboratiGrafici"),
                //       keyTranslateTitle: "properties.documents.gestAmmelaboratiGrafici",
                //       type: "doc",
                //       content: items
                //     });
                //   }
                //   if (typeof res.data.gestAmmApe !== 'undefined') {
                //     const items = this.getDocsFromSection(res.data.gestAmmApe);
                //     contents.push({
                //       title: this.translateService.instant("properties.documents.gestAmmApe"),
                //       keyTranslateTitle: "properties.documents.gestAmmApe",
                //       type: "doc",
                //       content: items
                //     });
                //   }
                //   this.allDocs.push({
                //     keyTranslateTitle: "properties.documents.amministrativiImmobile",
                //     title: this.translateService.instant("properties.documents.amministrativiImmobile"),
                //     type: "title",
                //     content: contents
                //   })
                // }
                //
                // CATASTO
                //
                if ((typeof res.data.catastoCatastoTerreni !== 'undefined'
                    || typeof res.data.catastoCatastoFabbricati !== 'undefined')
                    && _this.currentRole.propertiesPermission.catasto) {
                    var contents = [];
                    if (typeof res.data.catastoCatastoTerreni !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.catastoCatastoTerreni);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.catastoCatastoTerreni"),
                            keyTranslateTitle: "properties.documents.catastoCatastoTerreni",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.catastoCatastoFabbricati !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.catastoCatastoFabbricati);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.catastoCatastoFabbricati"),
                            keyTranslateTitle: "properties.documents.catastoCatastoFabbricati",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.catasto",
                        title: _this.translateService.instant("properties.documents.catasto"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // URBANISTICA ED EDILIZIA
                //
                if ((typeof res.data.urbedilurbanistedEdili !== 'undefined'
                    || typeof res.data.urbedilcondoni !== 'undefined'
                    || typeof res.data.urbedilautorizzazioni !== 'undefined')
                    && _this.currentRole.propertiesPermission.urbanisticaEdEdilizia) {
                    var contents = [];
                    if (typeof res.data.urbedilurbanistedEdili !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.urbedilurbanistedEdili);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.urbedilurbanistedEdili"),
                            keyTranslateTitle: "properties.documents.urbedilurbanistedEdili",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.urbedilcondoni !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.urbedilcondoni);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.urbedilcondoni"),
                            keyTranslateTitle: "properties.documents.urbedilcondoni",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.urbedilautorizzazioni !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.urbedilautorizzazioni);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.urbedilautorizzazioni"),
                            keyTranslateTitle: "properties.documents.urbedilautorizzazioni",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.urbanisticaEdEdilizia",
                        title: _this.translateService.instant("properties.documents.urbanisticaEdEdilizia"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // STACKINGPLAN
                //
                if (typeof res.data.stackingPlan !== 'undefined') {
                    var contents = [];
                    if (typeof res.data.stackingPlan !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.stackingPlan);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.stackingPlan"),
                            keyTranslateTitle: "properties.documents.stackingPlan",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.stackingPlan",
                        title: _this.translateService.instant("properties.documents.stackingPlan"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // REPORTISTICA
                //
                if (typeof res.data.reportistica !== 'undefined') {
                    var contents = [];
                    if (typeof res.data.reportistica !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.reportistica);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.reportistica"),
                            keyTranslateTitle: "properties.documents.reportistica",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.reportistica",
                        title: _this.translateService.instant("properties.documents.reportistica"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // CONTRATTI DI LOCAZIONE
                //
                if (typeof res.data.locazioneContrdiLocazione !== 'undefined') {
                    var contents = [];
                    if (typeof res.data.locazioneContrdiLocazione !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.locazioneContrdiLocazione);
                        var items2_3 = [];
                        items.forEach(function (elem) {
                            var index = items2_3.findIndex(function (subElem) {
                                return subElem.title === elem.data.nomeConduttore;
                            });
                            if (index > -1) {
                                items2_3[index].content.push(elem);
                            }
                            else {
                                items2_3.push({
                                    title: elem.data.nomeConduttore,
                                    active: true,
                                    type: "title",
                                    docId: undefined,
                                    structureId: "",
                                    content: [elem]
                                });
                            }
                        });
                        if (items2_3.length) {
                            contents.push({
                                title: _this.translateService.instant("properties.documents.locazioneContrdiLocazione"),
                                keyTranslateTitle: "properties.documents.locazioneContrdiLocazione",
                                type: "title",
                                content: items2_3
                            });
                        }
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.locazioneContrdiLocazione",
                        title: _this.translateService.instant("properties.documents.locazioneContrdiLocazione"),
                        type: "title",
                        content: contents
                    });
                }
                if (_this.currentRole.propertiesPermission.contratti) {
                    var contents = [];
                    var itemsContract_1 = [];
                    itemsContract_1.push({
                        title: "",
                        active: true,
                        type: "title",
                        docId: "",
                        structureId: "",
                        content: [],
                    });
                    if (res.data.contratti.length) {
                        res.data.contratti.forEach(function (elem) {
                            var subDocs = [];
                            var active = true;
                            var title = "";
                            if (elem.structureObjectId === "-1") { //contratti generici
                                subDocs = _this.getDocsFromContractSection(elem, "properties.documents.contratti");
                                //title = this.translateService.instant("properties.documents.genericContracts");
                                title = "";
                            }
                            else {
                                var structure = _this.condoStructure[elem.structureObjectType]
                                    ? _this.condoStructure[elem.structureObjectType].find(function (item) {
                                        return item._id === elem.structureObjectId;
                                    })
                                    : undefined;
                                if (structure && structure.active) {
                                    if (typeof structure.codicePod !== "undefined" && structure.codicePod !== "") {
                                        title = structure.codicePod;
                                    }
                                    else {
                                        if (structure.nome) {
                                            title = structure.nome;
                                        }
                                    }
                                    subDocs = _this.getDocsFromContractSection(elem, "properties.documents.contratti");
                                }
                                else {
                                    active = false;
                                    title = "";
                                }
                            }
                            subDocs.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title, structureId: elem.structureObjectId, active: active, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    var subDocs_1 = [];
                    var active_1 = true;
                    var title_1 = "";
                    if (typeof res.data.gestAmmTivoGestionali !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.gestAmmTivoGestionali, "properties.documents.gestAmmTivoGestionali");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (typeof res.data.gestAmmTivoAssicurazioni !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.gestAmmTivoAssicurazioni, "properties.documents.gestAmmTivoAssicurazioni");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (typeof res.data.impelegenerale !== "undefined") {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.impelegenerale, "properties.documents.impelegenerale");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (typeof res.data.tratAcquaReteIdricaSanitari !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.tratAcquaReteIdricaSanitari, "properties.documents.tratAcquaReteIdricaSanitari");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (res.data.tratAcquaCentraleIdrica.length) {
                        res.data.tratAcquaCentraleIdrica.forEach(function (elem) {
                            var structureName = _this.condoStructure.centraleIdricaPropria
                                ? _this.condoStructure.centraleIdricaPropria.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.tratAcquaCentraleIdrica");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.tratAcquaSottAlimDaBsc.length) {
                        res.data.tratAcquaSottAlimDaBsc.forEach(function (elem) {
                            var structureName = _this.condoStructure.sottostazioneAltroCondBsc
                                ? _this.condoStructure.sottostazioneAltroCondBsc.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.tratAcquaSottAlimDaBsc");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (typeof res.data.gestAmmTivoGestioneDipend !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.gestAmmTivoGestioneDipend, "properties.documents.gestAmmTivoGestioneDipend");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (typeof res.data.gestAmmTivoBanca !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.gestAmmTivoBanca, "properties.documents.gestAmmTivoBanca");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (typeof res.data.impeleMediaTensione !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.impeleMediaTensione, "properties.documents.impeleMediaTensione");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (res.data.incendioReteSprinkler.length) {
                        res.data.incendioReteSprinkler.forEach(function (elem) {
                            var structureName = _this.condoStructure.reteSprinkler
                                ? _this.condoStructure.reteSprinkler.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.incendioReteSprinkler");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.incendioReteIdranti.length) {
                        res.data.incendioReteIdranti.forEach(function (elem) {
                            var structureName = _this.condoStructure.reteIdranti
                                ? _this.condoStructure.reteIdranti.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.incendioReteIdranti");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.tratAcquaContatoreAcqua.length) {
                        res.data.tratAcquaContatoreAcqua.forEach(function (elem) {
                            var structureName = _this.condoStructure.contatoriAcqua
                                ? _this.condoStructure.contatoriAcqua.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.tratAcquaContatoreAcqua");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscaldgasMetcontatrete.length) {
                        res.data.riscaldgasMetcontatrete.forEach(function (elem) {
                            var structureName = _this.condoStructure.contatoreGas
                                ? _this.condoStructure.contatoreGas.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscaldgasMetcontatrete");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.serbatoioAGasolio.length) {
                        res.data.serbatoioAGasolio.forEach(function (elem) {
                            var structureName = _this.condoStructure.serbatoiAGasolio
                                ? _this.condoStructure.serbatoiAGasolio.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.serbatoioAGasolio");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscaldrisccentraliz.length) {
                        res.data.riscaldrisccentraliz.forEach(function (elem) {
                            var structureName = _this.condoStructure.centraleTermica
                                ? _this.condoStructure.centraleTermica.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscaldrisccentraliz");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscaldcentrteleriscaldamen.length) {
                        res.data.riscaldcentrteleriscaldamen.forEach(function (elem) {
                            var structureName = _this.condoStructure.teleriscaldamento
                                ? _this.condoStructure.teleriscaldamento.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscaldcentrteleriscaldamen");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscGeotermicoPozzi.length) {
                        res.data.riscGeotermicoPozzi.forEach(function (elem) {
                            var structureName = _this.condoStructure.geotermicoConPozzi
                                ? _this.condoStructure.geotermicoConPozzi.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscGeotermicoPozzi");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscGeotermicoSonde.length) {
                        res.data.riscGeotermicoSonde.forEach(function (elem) {
                            var structureName = _this.condoStructure.geotermicoConSonde
                                ? _this.condoStructure.geotermicoConSonde.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscGeotermicoSonde");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscaldsoloPompeDiCalore.length) {
                        res.data.riscaldsoloPompeDiCalore.forEach(function (elem) {
                            var structureName = _this.condoStructure.pompeDiCalore
                                ? _this.condoStructure.pompeDiCalore.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscaldsoloPompeDiCalore");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscaldcentrRicevBsc.length) {
                        res.data.riscaldcentrRicevBsc.forEach(function (elem) {
                            var structureName = _this.condoStructure.centraleRicervimento
                                ? _this.condoStructure.centraleRicervimento.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscaldcentrRicevBsc");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.ascensoriEMontautoAscensori.length) {
                        res.data.ascensoriEMontautoAscensori.forEach(function (elem) {
                            var structureName = _this.condoStructure.ascensore
                                ? _this.condoStructure.ascensore.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.ascensoriEMontautoAscensori");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.ascensoriEMontautoMontauto.length) {
                        res.data.ascensoriEMontautoMontauto.forEach(function (elem) {
                            var structureName = _this.condoStructure.montauto
                                ? _this.condoStructure.montauto.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.ascensoriEMontautoMontauto");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.incendioEstintori.length) {
                        res.data.incendioEstintori.forEach(function (elem) {
                            var structureName = _this.condoStructure.estintori
                                ? _this.condoStructure.estintori.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            // title = this.translateService.instant("properties.documents.incendioEstintori");
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.incendioEstintori");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.incendioStazionePompaggio.length) {
                        res.data.incendioStazionePompaggio.forEach(function (elem) {
                            var structureName = _this.condoStructure.stazionePompaggio
                                ? _this.condoStructure.stazionePompaggio.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.incendioStazionePompaggio");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (typeof res.data.edileporteRei !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.edileporteRei, "properties.documents.edileporteRei");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (res.data.incendioRilevazione.length) {
                        res.data.incendioRilevazione.forEach(function (elem) {
                            var structureName = _this.condoStructure.rilevazioneFumi
                                ? _this.condoStructure.rilevazioneFumi.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.incendioRilevazione");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.incendioVentilazione.length) {
                        res.data.incendioVentilazione.forEach(function (elem) {
                            var structureName = _this.condoStructure.ventilazione
                                ? _this.condoStructure.ventilazione.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.incendioVentilazione");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscaldimpcondizionamento.length) {
                        res.data.riscaldimpcondizionamento.forEach(function (elem) {
                            var structureName = _this.condoStructure.climatizzazione
                                ? _this.condoStructure.climatizzazione.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscaldimpcondizionamento");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impElettroniciautomazioni.length) {
                        res.data.impElettroniciautomazioni.forEach(function (elem) {
                            var structureName = _this.condoStructure.automazCancelli
                                ? _this.condoStructure.automazCancelli.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impElettroniciautomazioni");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.lineaVita.length) {
                        res.data.lineaVita.forEach(function (elem) {
                            var structureName = _this.condoStructure.lineeVita
                                ? _this.condoStructure.lineeVita.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.lineaVita");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (typeof res.data.amiantoDoc !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.amiantoDoc, "properties.documents.amiantoDoc");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (res.data.impeleGruppoElettrogeno.length) {
                        res.data.impeleGruppoElettrogeno.forEach(function (elem) {
                            var structureName = _this.condoStructure.gruppoElettrogeno
                                ? _this.condoStructure.gruppoElettrogeno.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impeleGruppoElettrogeno");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.tratAcquaPompSollacqpiov.length) {
                        res.data.tratAcquaPompSollacqpiov.forEach(function (elem) {
                            var structureName = _this.condoStructure.sollevamAcquePiovNere
                                ? _this.condoStructure.sollevamAcquePiovNere.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.tratAcquaPompSollacqpiov");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impeleFotovoltaico.length) {
                        res.data.impeleFotovoltaico.forEach(function (elem) {
                            var structureName = _this.condoStructure.fotovoltaico
                                ? _this.condoStructure.fotovoltaico.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impeleFotovoltaico");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impelescaricheAtmosferiche.length) {
                        res.data.impelescaricheAtmosferiche.forEach(function (elem) {
                            var structureName = _this.condoStructure.scaricheAtmosferiche
                                ? _this.condoStructure.scaricheAtmosferiche.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impelescaricheAtmosferiche");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impElettroniciimpCitofonico.length) {
                        res.data.impElettroniciimpCitofonico.forEach(function (elem) {
                            var structureName = _this.condoStructure.citoVideo
                                ? _this.condoStructure.citoVideo.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impElettroniciimpCitofonico");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impElettroniciimpiantoTvcc.length) {
                        res.data.impElettroniciimpiantoTvcc.forEach(function (elem) {
                            var structureName = _this.condoStructure.tvCc
                                ? _this.condoStructure.tvCc.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impElettroniciimpiantoTvcc");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impElettroniciantintrusione.length) {
                        res.data.impElettroniciantintrusione.forEach(function (elem) {
                            var structureName = _this.condoStructure.impAntintrusione
                                ? _this.condoStructure.impAntintrusione.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impElettroniciantintrusione");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impricreativipiscina.length) {
                        res.data.impricreativipiscina.forEach(function (elem) {
                            var structureName = _this.condoStructure.piscina
                                ? _this.condoStructure.piscina.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impricreativipiscina");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impElettronicitvTerrestre.length) {
                        res.data.impElettronicitvTerrestre.forEach(function (elem) {
                            var structureName = _this.condoStructure.tvTerrestre
                                ? _this.condoStructure.tvTerrestre.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impElettronicitvTerrestre");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.impElettronicitvSatellitare.length) {
                        res.data.impElettronicitvSatellitare.forEach(function (elem) {
                            var structureName = _this.condoStructure.tvSatellitare
                                ? _this.condoStructure.tvSatellitare.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.impElettronicitvSatellitare");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (res.data.riscaldsolareTermico.length) {
                        res.data.riscaldsolareTermico.forEach(function (elem) {
                            var structureName = _this.condoStructure.solareTermico
                                ? _this.condoStructure.solareTermico.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            title_1 = (structureName) ? structureName.nome : "";
                            active_1 = (structureName) ? structureName.active : false;
                            subDocs_1 = _this.getDocsFromContractSection(elem, "properties.documents.riscaldsolareTermico");
                            subDocs_1.forEach(function (subElem) {
                                var element = tslib_1.__assign({ structureTitle: title_1, structureId: elem.structureObjectId, active: active_1, documentId: elem._id }, subElem);
                                itemsContract_1[0].content.push(element);
                            });
                        });
                    }
                    if (typeof res.data.edilestrutture !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.edilestrutture, "properties.documents.edilestrutture");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (typeof res.data.edileinterventiSuccessivi !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.edileinterventiSuccessivi, "properties.documents.edileinterventiSuccessivi");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (typeof res.data.edilereteFognaria !== 'undefined') {
                        subDocs_1 = _this.getDocsFromContractSection(res.data.edilereteFognaria, "properties.documents.edilereteFognaria");
                        subDocs_1.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "-1", active: true, documentId: "" }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                    }
                    if (itemsContract_1[0].content.length) {
                        itemsContract_1[0].content.sort(_this.compareExpired);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.contratti"),
                            keyTranslateTitle: "properties.documents.contratti",
                            type: "contract",
                            content: itemsContract_1
                        });
                        _this.allDocs.push({
                            keyTranslateTitle: "properties.documents.contratti",
                            title: _this.translateService.instant("properties.documents.contratti"),
                            type: "title",
                            content: contents
                        });
                    }
                }
                //
                // LINEA VITA
                //
                if (typeof res.data.lineaVita !== 'undefined' && res.data.lineaVita.length
                    && _this.currentRole.propertiesPermission.lineaVita) {
                    var contents = [];
                    if (res.data.lineaVita.length) {
                        var items = res.data.lineaVita.map(function (elem) {
                            var structureName = _this.condoStructure.lineeVita
                                ? _this.condoStructure.lineeVita.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.lineaVita"),
                            keyTranslateTitle: "properties.documents.lineaVita",
                            type: "title",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.lineaVita",
                        title: _this.translateService.instant("properties.documents.lineaVita"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // AMIANTO
                //
                if (typeof res.data.amiantoDoc !== 'undefined'
                    && _this.currentRole.propertiesPermission.amiantoDoc) {
                    var contents = [];
                    if (typeof res.data.amiantoDoc !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.amiantoDoc);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.amiantoDoc"),
                            keyTranslateTitle: "properties.documents.amiantoDoc",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.amiantoDoc",
                        title: _this.translateService.instant("properties.documents.amiantoDoc"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // EDILE
                //
                if ((typeof res.data.ediledocumentiDiCostruz !== 'undefined'
                    || typeof res.data.edilemuratureRei !== 'undefined'
                    || typeof res.data.edileporteRei !== 'undefined'
                    || typeof res.data.edileinterventiSuccessivi !== 'undefined'
                    || typeof res.data.edilestrutture !== 'undefined'
                    || typeof res.data.edilereteFognaria !== 'undefined')
                    && _this.currentRole.propertiesPermission.edile) {
                    var contents = [];
                    if (typeof res.data.ediledocumentiDiCostruz !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.ediledocumentiDiCostruz);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.ediledocumentiDiCostruz"),
                            keyTranslateTitle: "properties.documents.ediledocumentiDiCostruz",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.edilemuratureRei !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.edilemuratureRei);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.edilemuratureRei"),
                            keyTranslateTitle: "properties.documents.edilemuratureRei",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.edileporteRei !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.edileporteRei);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.edileporteRei"),
                            keyTranslateTitle: "",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.edileinterventiSuccessivi !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.edileinterventiSuccessivi);
                        // contents.push({
                        //   title: this.translateService.instant("properties.documents.edileinterventiSuccessivi"),
                        //   keyTranslateTitle: "properties.documents.edileinterventiSuccessivi",
                        //   type: "doc",
                        //   content: items
                        // });
                        var items2_4 = [];
                        items.forEach(function (elem) {
                            var index = items2_4.findIndex(function (subElem) {
                                return subElem.title === elem.data.nomeArchiviazioneIntervento;
                            });
                            if (index > -1) {
                                items2_4[index].content.push(elem);
                            }
                            else {
                                items2_4.push({
                                    title: elem.data.nomeArchiviazioneIntervento,
                                    active: true,
                                    type: "title",
                                    docId: undefined,
                                    structureId: "",
                                    content: [elem]
                                });
                            }
                        });
                        if (items2_4.length) {
                            contents.push({
                                title: _this.translateService.instant("properties.documents.edileinterventiSuccessivi"),
                                keyTranslateTitle: "properties.documents.edileinterventiSuccessivi",
                                type: "title",
                                content: items2_4
                            });
                        }
                    }
                    if (typeof res.data.edilestrutture !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.edilestrutture);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.edilestrutture"),
                            keyTranslateTitle: "properties.documents.edilestrutture",
                            type: "doc",
                            content: items
                        });
                    }
                    if (typeof res.data.edilereteFognaria !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.edilereteFognaria);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.edilereteFognaria"),
                            keyTranslateTitle: "properties.documents.edilereteFognaria",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.edile",
                        title: _this.translateService.instant("properties.documents.edile"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // IMPIANTI ELETTRICI
                //
                if ((typeof res.data.impelegenerale !== 'undefined'
                    || typeof res.data.impeleMediaTensione !== 'undefined'
                    || res.data.impeleGruppoElettrogeno.length
                    || res.data.impeleFotovoltaico.length
                    || res.data.impelescaricheAtmosferiche.length)
                    && _this.currentRole.propertiesPermission.impiantoElettrico) {
                    var contents = [];
                    // if (res.data.impelegenerale.length) {
                    //   const items = res.data.impelegenerale.map((elem: any) => {
                    //     const structureName = this.condoStructure.fornituraBt
                    //       ? this.condoStructure.fornituraBt.find((item: any) => {
                    //         return item._id === elem.structureObjectId;
                    //       })
                    //       : undefined;
                    //     return {
                    //       title: (structureName) ? structureName.nome : "",
                    //       active: (structureName) ? structureName.active : false,
                    //       type: "title",
                    //       docId: elem._id,
                    //       structureId: elem.structureObjectId,
                    //       content: this.getDocsFromSection(elem),
                    //     };
                    //   });
                    //   contents.push({
                    //     title: this.translateService.instant("properties.documents.impelegenerale"),
                    //     keyTranslateTitle: "properties.documents.impelegenerale",
                    //     type: "title",
                    //     content: items
                    //   });
                    // }
                    if (typeof res.data.impelegenerale !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.impelegenerale);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impelegenerale"),
                            keyTranslateTitle: "properties.documents.impelegenerale",
                            type: "doc",
                            content: items
                        });
                    }
                    // if (res.data.impeleMediaTensione.length) {
                    //   const items = res.data.impeleMediaTensione.map((elem: any) => {
                    //     const structureName = this.condoStructure.fornituraMt
                    //       ? this.condoStructure.fornituraMt.find((item: any) => {
                    //         return item._id === elem.structureObjectId;
                    //       })
                    //       : undefined;
                    //     return {
                    //       title: (structureName) ? structureName.nome : "",
                    //       active: (structureName) ? structureName.active : false,
                    //       type: "title",
                    //       docId: elem._id,
                    //       structureId: elem.structureObjectId,
                    //       content: this.getDocsFromSection(elem),
                    //     };
                    //   });
                    //   contents.push({
                    //     title: this.translateService.instant("properties.documents.impeleMediaTensione"),
                    //     keyTranslateTitle: "properties.documents.impeleMediaTensione",
                    //     type: "title",
                    //     content: items
                    //   });
                    // }
                    if (typeof res.data.impeleMediaTensione !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.impeleMediaTensione);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impeleMediaTensione"),
                            keyTranslateTitle: "properties.documents.impeleMediaTensione",
                            type: "doc",
                            content: items
                        });
                    }
                    if (res.data.impeleGruppoElettrogeno.length) {
                        var items = res.data.impeleGruppoElettrogeno.map(function (elem) {
                            var structureName = _this.condoStructure.gruppoElettrogeno
                                ? _this.condoStructure.gruppoElettrogeno.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impeleGruppoElettrogeno"),
                            keyTranslateTitle: "properties.documents.impeleGruppoElettrogeno",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impeleFotovoltaico.length) {
                        var items = res.data.impeleFotovoltaico.map(function (elem) {
                            var structureName = _this.condoStructure.fotovoltaico
                                ? _this.condoStructure.fotovoltaico.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impeleFotovoltaico"),
                            keyTranslateTitle: "properties.documents.impeleFotovoltaico",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impelescaricheAtmosferiche.length) {
                        var items = res.data.impelescaricheAtmosferiche.map(function (elem) {
                            var structureName = _this.condoStructure.scaricheAtmosferiche
                                ? _this.condoStructure.scaricheAtmosferiche.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impelescaricheAtmosferiche"),
                            keyTranslateTitle: "properties.documents.impelescaricheAtmosferiche",
                            type: "title",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.impiantoElettrico",
                        title: _this.translateService.instant("properties.documents.impiantoElettrico"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // RISCALDAMENTO/CONDIZIONAMENTO
                //
                if ((res.data.riscaldrisccentraliz.length
                    || res.data.serbatoioAGasolio.length
                    || res.data.riscaldgasMetcontatrete.length
                    || res.data.riscaldsottostazriscaldamen.length
                    || res.data.riscaldcanneFumariePerCt.length
                    || res.data.riscaldsolareTermico.length
                    || res.data.riscaldcentrteleriscaldamen.length
                    || res.data.riscGeotermicoPozzi.length
                    || res.data.riscGeotermicoSonde.length
                    || res.data.riscaldsoloPompeDiCalore.length
                    || res.data.riscaldcentrRicevBsc.length
                    || res.data.riscaldimpcondizionamento.length
                    || (typeof res.data.risccanneFumarieColl !== "undefined"
                        && res.data.risccanneFumarieColl.length))
                    && _this.currentRole.propertiesPermission.riscaldamentoCondizionamento) {
                    var contents = [];
                    if (res.data.riscaldgasMetcontatrete.length) {
                        var items = res.data.riscaldgasMetcontatrete.map(function (elem) {
                            var structureName = _this.condoStructure.contatoreGas
                                ? _this.condoStructure.contatoreGas.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldgasMetcontatrete"),
                            keyTranslateTitle: "properties.documents.riscaldgasMetcontatrete",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscaldrisccentraliz.length) {
                        var items = res.data.riscaldrisccentraliz.map(function (elem) {
                            var structureName = _this.condoStructure.centraleTermica
                                ? _this.condoStructure.centraleTermica.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldrisccentraliz"),
                            keyTranslateTitle: "properties.documents.riscaldrisccentraliz",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.serbatoioAGasolio.length) {
                        var items = res.data.serbatoioAGasolio.map(function (elem) {
                            var structureName = _this.condoStructure.serbatoiAGasolio
                                ? _this.condoStructure.serbatoiAGasolio.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.serbatoioAGasolio"),
                            keyTranslateTitle: "properties.documents.serbatoioAGasolio",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscaldsottostazriscaldamen.length) {
                        var items = res.data.riscaldsottostazriscaldamen.map(function (elem) {
                            var structureName = _this.condoStructure.sottostazioniCt
                                ? _this.condoStructure.sottostazioniCt.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldsottostazriscaldamen"),
                            keyTranslateTitle: "properties.documents.riscaldsottostazriscaldamen",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscaldcanneFumariePerCt.length) {
                        var items = res.data.riscaldcanneFumariePerCt.map(function (elem) {
                            var structureName = _this.condoStructure.cannaFumaria
                                ? _this.condoStructure.cannaFumaria.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldcanneFumariePerCt"),
                            keyTranslateTitle: "properties.documents.riscaldcanneFumariePerCt",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscaldsolareTermico.length) {
                        var items = res.data.riscaldsolareTermico.map(function (elem) {
                            var structureName = _this.condoStructure.solareTermico
                                ? _this.condoStructure.solareTermico.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldsolareTermico"),
                            keyTranslateTitle: "properties.documents.riscaldsolareTermico",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscaldcentrteleriscaldamen.length) {
                        var items = res.data.riscaldcentrteleriscaldamen.map(function (elem) {
                            var structureName = _this.condoStructure.teleriscaldamento
                                ? _this.condoStructure.teleriscaldamento.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldcentrteleriscaldamen"),
                            keyTranslateTitle: "properties.documents.riscaldcentrteleriscaldamen",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscGeotermicoPozzi.length) {
                        var items = res.data.riscGeotermicoPozzi.map(function (elem) {
                            var structureName = _this.condoStructure.geotermicoConPozzi
                                ? _this.condoStructure.geotermicoConPozzi.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscGeotermicoPozzi"),
                            keyTranslateTitle: "properties.documents.riscGeotermicoPozzi",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscGeotermicoSonde.length) {
                        var items = res.data.riscGeotermicoSonde.map(function (elem) {
                            var structureName = _this.condoStructure.geotermicoConSonde
                                ? _this.condoStructure.geotermicoConSonde.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscGeotermicoSonde"),
                            keyTranslateTitle: "properties.documents.riscGeotermicoSonde",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscaldsoloPompeDiCalore.length) {
                        var items = res.data.riscaldsoloPompeDiCalore.map(function (elem) {
                            var structureName = _this.condoStructure.pompeDiCalore
                                ? _this.condoStructure.pompeDiCalore.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldsoloPompeDiCalore"),
                            keyTranslateTitle: "properties.documents.riscaldsoloPompeDiCalore",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscaldcentrRicevBsc.length) {
                        var items = res.data.riscaldcentrRicevBsc.map(function (elem) {
                            var structureName = _this.condoStructure.centraleRicervimento
                                ? _this.condoStructure.centraleRicervimento.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldcentrRicevBsc"),
                            keyTranslateTitle: "properties.documents.riscaldcentrRicevBsc",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.riscaldimpcondizionamento.length) {
                        var items = res.data.riscaldimpcondizionamento.map(function (elem) {
                            var structureName = _this.condoStructure.climatizzazione
                                ? _this.condoStructure.climatizzazione.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.riscaldimpcondizionamento"),
                            keyTranslateTitle: "properties.documents.riscaldimpcondizionamento",
                            type: "title",
                            content: items
                        });
                    }
                    if ((typeof res.data.risccanneFumarieColl !== "undefined"
                        && res.data.risccanneFumarieColl.length)) {
                        var items = res.data.risccanneFumarieColl.map(function (elem) {
                            var structureName = _this.condoStructure.cannaCollettiva
                                ? _this.condoStructure.cannaCollettiva.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.risccanneFumarieColl"),
                            keyTranslateTitle: "properties.documents.risccanneFumarieColl",
                            type: "title",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.riscaldamentoCondizionamento",
                        title: _this.translateService.instant("properties.documents.riscaldamentoCondizionamento"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // ASCENSORI E MONTAUTO
                //
                if ((res.data.ascensoriEMontautoAscensori.length
                    || res.data.ascensoriEMontautoMontauto.length)
                    && _this.currentRole.propertiesPermission.ascensori) {
                    var contents = [];
                    if (res.data.ascensoriEMontautoAscensori.length) {
                        var items = res.data.ascensoriEMontautoAscensori.map(function (elem) {
                            var structureName = _this.condoStructure.ascensore
                                ? _this.condoStructure.ascensore.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.ascensoriEMontautoAscensori"),
                            keyTranslateTitle: "properties.documents.ascensoriEMontautoAscensori",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.ascensoriEMontautoMontauto.length) {
                        var items = res.data.ascensoriEMontautoMontauto.map(function (elem) {
                            var structureName = _this.condoStructure.montauto
                                ? _this.condoStructure.montauto.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.ascensoriEMontautoMontauto"),
                            keyTranslateTitle: "properties.documents.ascensoriEMontautoMontauto",
                            type: "title",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.ascensoriEMontauto",
                        title: _this.translateService.instant("properties.documents.ascensoriEMontauto"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // TRATTAMENTO ACQUA
                //
                if ((res.data.tratAcquaContatoreAcqua.length
                    || res.data.tratAcquaCentraleIdrica.length
                    || res.data.tratAcquaSottAlimDaBsc.length
                    || res.data.tratAcquaPompSollacqpiov.length
                    || typeof res.data.tratAcquaReteIdricaSanitari !== 'undefined')
                    && _this.currentRole.propertiesPermission.trattamentoAcqua) {
                    var contents = [];
                    if (res.data.tratAcquaContatoreAcqua.length) {
                        var items = res.data.tratAcquaContatoreAcqua.map(function (elem) {
                            var structureName = _this.condoStructure.contatoriAcqua
                                ? _this.condoStructure.contatoriAcqua.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.tratAcquaContatoreAcqua"),
                            keyTranslateTitle: "properties.documents.tratAcquaContatoreAcqua",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.tratAcquaCentraleIdrica.length) {
                        var items = res.data.tratAcquaCentraleIdrica.map(function (elem) {
                            var structureName = _this.condoStructure.centraleIdricaPropria
                                ? _this.condoStructure.centraleIdricaPropria.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.tratAcquaCentraleIdrica"),
                            keyTranslateTitle: "properties.documents.tratAcquaCentraleIdrica",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.tratAcquaSottAlimDaBsc.length) {
                        var items = res.data.tratAcquaSottAlimDaBsc.map(function (elem) {
                            var structureName = _this.condoStructure.sottostazioneAltroCondBsc
                                ? _this.condoStructure.sottostazioneAltroCondBsc.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.tratAcquaSottAlimDaBsc"),
                            keyTranslateTitle: "properties.documents.tratAcquaSottAlimDaBsc",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.tratAcquaPompSollacqpiov.length) {
                        var items = res.data.tratAcquaPompSollacqpiov.map(function (elem) {
                            var structureName = _this.condoStructure.sollevamAcquePiovNere
                                ? _this.condoStructure.sollevamAcquePiovNere.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.tratAcquaPompSollacqpiov"),
                            keyTranslateTitle: "properties.documents.tratAcquaPompSollacqpiov",
                            type: "title",
                            content: items
                        });
                    }
                    if (typeof res.data.tratAcquaReteIdricaSanitari !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.tratAcquaReteIdricaSanitari);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.tratAcquaReteIdricaSanitari"),
                            keyTranslateTitle: "properties.documents.tratAcquaReteIdricaSanitari",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.trattamentoAcqua",
                        title: _this.translateService.instant("properties.documents.trattamentoAcqua"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // IMPIANTO ELETTRONICO
                //
                if ((res.data.impElettronicitvTerrestre.length
                    || res.data.impElettronicitvSatellitare.length
                    || res.data.impElettroniciautomazioni.length
                    || res.data.impElettroniciimpCitofonico.length
                    || res.data.impElettroniciimpiantoTvcc.length
                    || res.data.impElettroniciantintrusione.length)
                    && _this.currentRole.propertiesPermission.impiantiElettronici) {
                    var contents = [];
                    if (res.data.impElettronicitvTerrestre.length) {
                        var items = res.data.impElettronicitvTerrestre.map(function (elem) {
                            var structureName = _this.condoStructure.tvTerrestre
                                ? _this.condoStructure.tvTerrestre.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impElettronicitvTerrestre"),
                            keyTranslateTitle: "properties.documents.impElettronicitvTerrestre",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impElettronicitvSatellitare.length) {
                        var items = res.data.impElettronicitvSatellitare.map(function (elem) {
                            var structureName = _this.condoStructure.tvSatellitare
                                ? _this.condoStructure.tvSatellitare.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impElettronicitvSatellitare"),
                            keyTranslateTitle: "properties.documents.impElettronicitvSatellitare",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impElettroniciautomazioni.length) {
                        var items = res.data.impElettroniciautomazioni.map(function (elem) {
                            var structureName = _this.condoStructure.automazCancelli
                                ? _this.condoStructure.automazCancelli.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impElettroniciautomazioni"),
                            keyTranslateTitle: "properties.documents.impElettroniciautomazioni",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impElettroniciimpCitofonico.length) {
                        var items = res.data.impElettroniciimpCitofonico.map(function (elem) {
                            var structureName = _this.condoStructure.citoVideo
                                ? _this.condoStructure.citoVideo.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impElettroniciimpCitofonico"),
                            keyTranslateTitle: "properties.documents.impElettroniciimpCitofonico",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impElettroniciimpiantoTvcc.length) {
                        var items = res.data.impElettroniciimpiantoTvcc.map(function (elem) {
                            var structureName = _this.condoStructure.tvCc
                                ? _this.condoStructure.tvCc.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impElettroniciimpiantoTvcc"),
                            keyTranslateTitle: "properties.documents.impElettroniciimpiantoTvcc",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impElettroniciantintrusione.length) {
                        var items = res.data.impElettroniciantintrusione.map(function (elem) {
                            var structureName = _this.condoStructure.impAntintrusione
                                ? _this.condoStructure.impAntintrusione.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impElettroniciantintrusione"),
                            keyTranslateTitle: "properties.documents.impElettroniciantintrusione",
                            type: "title",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.impiantiElettronici",
                        title: _this.translateService.instant("properties.documents.impiantiElettronici"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // PRATICA PREVENZIONE INCENDI
                //
                if (typeof res.data.vvFdefinitivo !== "undefined"
                    && res.data.vvFdefinitivo.length
                    && _this.currentRole.propertiesPermission.antincendio) {
                    var vvF = [];
                    var contents = [];
                    var items = res.data.vvFdefinitivo.map(function (elem) {
                        if (elem.structureObjectId === "-1") { //doc  generici
                            return {
                                title: _this.translateService.instant("properties.documents.genericVVF"),
                                active: true,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                                structureObjectType: "-1",
                            };
                        }
                        else {
                            var structureName = _this.condoStructure[elem.structureObjectType]
                                ? _this.condoStructure[elem.structureObjectType].find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: elem.structureObjectName,
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                                structureObjectType: elem.structureObjectType
                            };
                        }
                    });
                    var itemsOrdered_1 = [];
                    // fabbricatoAbitativo 77
                    items.forEach(function (elem) {
                        if (elem.structureObjectType === "fabbricatoAbitativo") {
                            itemsOrdered_1.push(elem);
                        }
                    });
                    // compartimentoBox 75
                    items.forEach(function (elem) {
                        if (elem.structureObjectType === "compartimentoBox") {
                            itemsOrdered_1.push(elem);
                        }
                    });
                    // centraleTermica 75
                    items.forEach(function (elem) {
                        if (elem.structureObjectType === "centraleTermica") {
                            itemsOrdered_1.push(elem);
                        }
                    });
                    // gruppoElettrogeno 49
                    items.forEach(function (elem) {
                        if (elem.structureObjectType === "gruppoElettrogeno") {
                            itemsOrdered_1.push(elem);
                        }
                    });
                    // attivitavvf 50
                    items.forEach(function (elem) {
                        if (elem.structureObjectType === "attivitavvf") {
                            itemsOrdered_1.push(elem);
                        }
                    });
                    // varie
                    items.forEach(function (elem) {
                        if (elem.structureObjectType === "-1") {
                            itemsOrdered_1.push(elem);
                        }
                    });
                    contents.push({
                        title: _this.translateService.instant("properties.documents.vvFdefinitivo"),
                        keyTranslateTitle: "properties.documents.vvFdefinitivo",
                        type: "title",
                        content: itemsOrdered_1
                    });
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.attivitaSottopostePrevenzioneIncendi",
                        title: _this.translateService.instant("properties.documents.attivitaSottopostePrevenzioneIncendi"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // ANTINCENDIO
                //
                if ((typeof res.data.sicurezzaAntincendioFacciate !== 'undefined'
                    || res.data.incendioEstintori.length
                    || res.data.incendioReteIdranti.length
                    || res.data.incendioReteSprinkler.length
                    || res.data.incendioStazionePompaggio.length
                    || res.data.incendioRilevazione.length
                    || res.data.incendioVentilazione.length
                    || typeof res.data.incendioEvac !== 'undefined')
                    && _this.currentRole.propertiesPermission.antincendio) {
                    var contents = [];
                    if (typeof res.data.sicurezzaAntincendioFacciate !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.sicurezzaAntincendioFacciate);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.sicurezzaAntincendioFacciate"),
                            keyTranslateTitle: "properties.documents.sicurezzaAntincendioFacciate",
                            type: "doc",
                            content: items
                        });
                    }
                    if (res.data.incendioEstintori.length) {
                        var items = res.data.incendioEstintori.map(function (elem) {
                            var structureName = _this.condoStructure.estintori
                                ? _this.condoStructure.estintori.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.incendioEstintori"),
                            keyTranslateTitle: "properties.documents.incendioEstintori",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.incendioReteIdranti.length) {
                        var items = res.data.incendioReteIdranti.map(function (elem) {
                            var structureName = _this.condoStructure.reteIdranti
                                ? _this.condoStructure.reteIdranti.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.incendioReteIdranti"),
                            keyTranslateTitle: "properties.documents.incendioReteIdranti",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.incendioReteSprinkler.length) {
                        var items = res.data.incendioReteSprinkler.map(function (elem) {
                            var structureName = _this.condoStructure.reteSprinkler
                                ? _this.condoStructure.reteSprinkler.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.incendioReteSprinkler"),
                            keyTranslateTitle: "properties.documents.incendioReteSprinkler",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.incendioStazionePompaggio.length) {
                        var items = res.data.incendioStazionePompaggio.map(function (elem) {
                            var structureName = _this.condoStructure.stazionePompaggio
                                ? _this.condoStructure.stazionePompaggio.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.incendioStazionePompaggio"),
                            keyTranslateTitle: "properties.documents.incendioStazionePompaggio",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.incendioRilevazione.length) {
                        var items = res.data.incendioRilevazione.map(function (elem) {
                            var structureName = _this.condoStructure.rilevazioneFumi
                                ? _this.condoStructure.rilevazioneFumi.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.incendioRilevazione"),
                            keyTranslateTitle: "properties.documents.incendioRilevazione",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.incendioVentilazione.length) {
                        var items = res.data.incendioVentilazione.map(function (elem) {
                            var structureName = _this.condoStructure.ventilazione
                                ? _this.condoStructure.ventilazione.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.incendioVentilazione"),
                            keyTranslateTitle: "properties.documents.incendioVentilazione",
                            type: "title",
                            content: items
                        });
                    }
                    if (typeof res.data.incendioEvac !== 'undefined') {
                        var items = _this.getDocsFromSection(res.data.incendioEvac);
                        contents.push({
                            title: _this.translateService.instant("properties.documents.incendioEvac"),
                            keyTranslateTitle: "properties.documents.incendioEvac",
                            type: "doc",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.impiantiAntincendio",
                        title: _this.translateService.instant("properties.documents.impiantiAntincendio"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // IMPIANTI SPECIALI
                //
                if (res.data.impiantiSpeciali.length
                    && _this.currentRole.propertiesPermission.impiantiSpeciali) {
                    var contents = [];
                    if (res.data.impiantiSpeciali.length) {
                        var items = res.data.impiantiSpeciali.map(function (elem) {
                            var structureName = _this.condoStructure.impiantoSpeciale
                                ? _this.condoStructure.impiantoSpeciale.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impiantiSpeciali"),
                            keyTranslateTitle: "properties.documents.impiantiSpeciali",
                            type: "title",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.impiantiSpeciali",
                        title: _this.translateService.instant("properties.documents.impiantiSpeciali"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // IMPIANTI RICREATIVI/SPORTIVI
                //
                if ((res.data.impricreativipiscina.length
                    || res.data.impricreativipalestra.length
                    || res.data.impricreativicampoTennis.length
                    || res.data.impricreativicampoCalcio.length
                    || res.data.impricreativiparcoGiochi.length)
                    && _this.currentRole.propertiesPermission.impiantiRicreativiSportivi) {
                    var contents = [];
                    if (res.data.impricreativipiscina.length) {
                        var items = res.data.impricreativipiscina.map(function (elem) {
                            var structureName = _this.condoStructure.piscina
                                ? _this.condoStructure.piscina.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impricreativipiscina"),
                            keyTranslateTitle: "properties.documents.impricreativipiscina",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impricreativipalestra.length) {
                        var items = res.data.impricreativipalestra.map(function (elem) {
                            var structureName = _this.condoStructure.palestra
                                ? _this.condoStructure.palestra.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impricreativipalestra"),
                            keyTranslateTitle: "properties.documents.impricreativipalestra",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impricreativicampoTennis.length) {
                        var items = res.data.impricreativicampoTennis.map(function (elem) {
                            var structureName = _this.condoStructure.campoTennis
                                ? _this.condoStructure.campoTennis.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impricreativicampoTennis"),
                            keyTranslateTitle: "properties.documents.impricreativicampoTennis",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impricreativicampoCalcio.length) {
                        var items = res.data.impricreativicampoCalcio.map(function (elem) {
                            var structureName = _this.condoStructure.campoCalcio
                                ? _this.condoStructure.campoCalcio.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impricreativicampoCalcio"),
                            keyTranslateTitle: "properties.documents.impricreativicampoCalcio",
                            type: "title",
                            content: items
                        });
                    }
                    if (res.data.impricreativiparcoGiochi.length) {
                        var items = res.data.impricreativiparcoGiochi.map(function (elem) {
                            var structureName = _this.condoStructure.parcoGiochi
                                ? _this.condoStructure.parcoGiochi.find(function (item) {
                                    return item._id === elem.structureObjectId;
                                })
                                : undefined;
                            return {
                                title: (structureName) ? structureName.nome : "",
                                active: (structureName) ? structureName.active : false,
                                type: "title",
                                docId: elem._id,
                                structureId: elem.structureObjectId,
                                content: _this.getDocsFromSection(elem),
                            };
                        });
                        contents.push({
                            title: _this.translateService.instant("properties.documents.impricreativiparcoGiochi"),
                            keyTranslateTitle: "properties.documents.impricreativiparcoGiochi",
                            type: "title",
                            content: items
                        });
                    }
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.impiantiRicreativiSportivi",
                        title: _this.translateService.instant("properties.documents.impiantiRicreativiSportivi"),
                        type: "title",
                        content: contents
                    });
                }
                //
                // UNITA' IMMOBILIARI
                // I documenti sono raggruppati per unità immobiliare
                if (_this.condoStructure.unitaAbitativaCommerciale
                    && Array.isArray(_this.condoStructure.unitaAbitativaCommerciale)
                    && _this.condoStructure.unitaAbitativaCommerciale.length
                    && _this.currentRole.propertiesPermission.unitaImmobiliari) {
                    var unitaImmobiliari_1 = [];
                    _this.condoStructure.unitaAbitativaCommerciale.forEach(function (el) {
                        var contents = [];
                        if (res.data.unitaimmvvf.length) {
                            var index = res.data.unitaimmvvf.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmvvf[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmvvf"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmvvf",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaImmdocAmm.length) {
                            var index = res.data.unitaImmdocAmm.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaImmdocAmm[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaImmdocAmm"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaImmdocAmm",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaimmelettrico.length) {
                            var index = res.data.unitaimmelettrico.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmelettrico[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmelettrico"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmelettrico",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaimmantintrusione.length) {
                            var index = res.data.unitaimmantintrusione.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmantintrusione[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmantintrusione"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmantintrusione",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaimmidricoSanitari.length) {
                            var index = res.data.unitaimmidricoSanitari.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmidricoSanitari[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmidricoSanitari"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmidricoSanitari",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaimmtermico.length) {
                            var index = res.data.unitaimmtermico.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmtermico[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmtermico"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmtermico",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaimmcondizionamento.length) {
                            var index = res.data.unitaimmcondizionamento.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmcondizionamento[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmcondizionamento"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmcondizionamento",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaimmape.length) {
                            var index = res.data.unitaimmape.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmape[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmape"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmape",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaimmelaboratiGrafici.length) {
                            var index = res.data.unitaimmelaboratiGrafici.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmelaboratiGrafici[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmelaboratiGrafici"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmelaboratiGrafici",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaimmcanneFumariePer.length) {
                            var index = res.data.unitaimmcanneFumariePer.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaimmcanneFumariePer[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaimmcanneFumariePer"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaimmcanneFumariePer",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        if (res.data.unitaImmsicurezza.length) {
                            var index = res.data.unitaImmsicurezza.findIndex(function (item) {
                                return el._id === item.structureObjectId;
                            });
                            if (index > -1) {
                                var elem = res.data.unitaImmsicurezza[index];
                                contents.push({
                                    title: _this.translateService.instant("properties.documents.unitaImmsicurezza"),
                                    active: true,
                                    keyTranslateTitle: "properties.documents.unitaImmsicurezza",
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem),
                                });
                            }
                        }
                        unitaImmobiliari_1.push({
                            title: el.nome,
                            type: "title",
                            content: contents
                        });
                    });
                    _this.allDocs.push({
                        keyTranslateTitle: "properties.documents.unitaImmobiliari",
                        title: _this.translateService.instant("properties.documents.unitaImmobiliari"),
                        type: "title",
                        content: unitaImmobiliari_1
                    });
                }
                //this.displayedDocs = this.allDocs;
                _this.countDocPerArea();
                if (_this.allDocs && Array.isArray(_this.allDocs) && _this.allDocs.length) {
                    _this.displayedDocs = _this.filterDisplayedDocs(_this.allDocs);
                }
            }
            else {
                _this.toastrService.error(res.message);
            }
            _this.documentArchiveIsLoading = false;
        });
    };
    ViewPropertyComponent.prototype.getDocumentArchiveData2 = function () {
        var _this = this;
        this.documentArchiveIsLoading = true;
        this.insertedDocs = [];
        this.documentArchivesService
            .get(this.property.get("documentArchive"))
            .subscribe(function (res) {
            if (res.status) {
                _this.documentArchive = res.data;
                if (_this.documentArchive.suppliersName) {
                    _this.suppliersName = _this.documentArchive.suppliersName;
                }
                if (_this.documentArchive.yearsOfStorage) {
                    _this.yearsOfStorage = _this.documentArchive.yearsOfStorage;
                }
                if (_this.documentArchive.conductorName) {
                    _this.conductorName = _this.documentArchive.conductorName;
                }
                if (_this.documentArchive.nameInterventionArchiving) {
                    _this.nameInterventionArchiving =
                        _this.documentArchive.nameInterventionArchiving;
                }
                _this.allDocs = _this.documentTypeStructure.getDocumentArchiveData(_this.lang, _this.documentTemplate, _this.condoStructure, _this.documentArchive, _this.subscriptionType, _this.insertedDocs);
                _this.countDocPerArea();
                if (_this.allDocs && Array.isArray(_this.allDocs) && _this.allDocs.length) {
                    _this.displayedDocs = _this.filterDisplayedDocs(_this.allDocs);
                }
            }
            else {
                _this.toastrService.error(res.message);
            }
            _this.documentArchiveIsLoading = false;
        });
    };
    /**
     * Utility: extracts documents from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.getDocsFromSection = function (section) {
        var _this = this;
        var docList = [];
        var _loop_1 = function (doc) {
            if (section.documents[doc].length) {
                section.documents[doc].forEach(function (item) {
                    if (!item.deleted && !item.expired) {
                        if (item.data &&
                            item.data.nomeSocietaEroganteInServizio &&
                            // && (item.data.rilasciatoFirmatoDa
                            //   || item.data.nomeDiRiferimento
                            //   || item.data.nomeSocietaEroganteInServizio)
                            typeof item.data.ragioneSocialeFornitore === "undefined") {
                            if (item.data.rilasciatoFirmatoDa) {
                                item.data["ragioneSocialeFornitore"] = item.data.rilasciatoFirmatoDa;
                            }
                            else if (item.data.nomeDiRiferimento) {
                                item.data["ragioneSocialeFornitore"] = item.data.nomeDiRiferimento;
                            }
                            else {
                                item.data["ragioneSocialeFornitore"] = item.data.nomeSocietaEroganteInServizio;
                            }
                        }
                        docList.push({
                            title: _this.translateService.instant("properties.documents.titles." + doc),
                            type: "doc",
                            docId: item._id,
                            key: doc,
                            mandatory: item.mandatory,
                            expired: item.expired,
                            deleted: item.deleted,
                            dateExpired: item.dateExpired,
                            data: item.data,
                        });
                    }
                    if (!item.deleted && item.data) {
                        _this.insertedDocs.push({
                            title: _this.translateService.instant("properties.documents.titles." + doc),
                            docId: item._id,
                            data: item.data,
                        });
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_1(doc);
        }
        return docList;
    };
    /**
     * Utility: extracts only contracts from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.getDocsFromContractSection = function (section, keyTranslateTitle) {
        var _this = this;
        var docList = [];
        var _loop_2 = function (doc) {
            if (section.documents[doc].length) {
                section.documents[doc].forEach(function (item) {
                    if (item.contract) {
                        if (!item.deleted && !item.expired) {
                            if (item.data &&
                                item.data.nomeSocietaEroganteInServizio &&
                                // && (item.data.rilasciatoFirmatoDa
                                //   || item.data.nomeDiRiferimento
                                //   || item.data.nomeSocietaEroganteInServizio)
                                typeof item.data.ragioneSocialeFornitore === "undefined") {
                                if (item.data.rilasciatoFirmatoDa) {
                                    item.data["ragioneSocialeFornitore"] = item.data.rilasciatoFirmatoDa;
                                }
                                else if (item.data.nomeDiRiferimento) {
                                    item.data["ragioneSocialeFornitore"] = item.data.nomeDiRiferimento;
                                }
                                else {
                                    item.data["ragioneSocialeFornitore"] = item.data.nomeSocietaEroganteInServizio;
                                }
                            }
                            docList.push({
                                title: _this.translateService.instant("properties.documents.titles." + doc),
                                type: "doc",
                                docId: item._id,
                                key: doc,
                                mandatory: item.mandatory,
                                expired: item.expired,
                                deleted: item.deleted,
                                dateExpired: item.dateExpired,
                                contract: item.contract,
                                pdfmsg: item.pdfmsg,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                            });
                        }
                        // only contracts
                        var contractSection = doc.substr(0, 2) === "HA" ? true : false;
                        if (!item.deleted && item.data && contractSection) {
                            _this.insertedDocs.push({
                                title: _this.translateService.instant("properties.documents.titles." + doc),
                                docId: item._id,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                            });
                        }
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_2(doc);
        }
        docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Order docs by expired property
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.compareExpired = function (a, b) {
        if (a.expired < b.expired) {
            return -1;
        }
        else if (a.expired > b.expired) {
            return 1;
        }
        else {
            return 0;
        }
    };
    /**
     * Count document per area and make visible the area in side menu.
     * Count mandatory, mandatory not inserted and generic document.
     * Show the counters into badge of side menu.
     * method used into getDocumentArchiveData()
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.countDocPerArea = function () {
        var _this = this;
        this.totMandatoryDocs = 0;
        this.totInsertDocs = 0;
        this.totNotInsertDocs = 0;
        this.totOptionalDocs = 0;
        this.totDocs = 0;
        // Hide all visible elements of side menu
        for (var key in this.documentsStructure) {
            this.documentsStructure[key].visible = false;
            if (Array.isArray(this.documentsStructure[key].content)) {
                this.documentsStructure[key].content.forEach(function (el) {
                    el.visible = false;
                });
            }
        }
        if (this.allDocs && Array.isArray(this.allDocs)) {
            this.allDocs.forEach(function (item) {
                var title = item.keyTranslateTitle;
                var levels = item.content;
                if (title !== "properties.documents.unitaImmobiliari" &&
                    title !== "properties.documents.attivitaSottopostePrevenzioneIncendi" &&
                    _this.filterMenuItem(title)) {
                    var _loop_3 = function (key) {
                        if (_this.documentsStructure[key].title === title) {
                            _this.documentsStructure[key].visible = true;
                            levels.forEach(function (el) {
                                _this.documentsStructure[key].content.forEach(function (subEl) {
                                    if (subEl.title === el.keyTranslateTitle) {
                                        subEl.visible = true;
                                        subEl.notInsert = 0;
                                        subEl.mandatory = 0;
                                        subEl.optional = 0;
                                        var inserted_1 = 0;
                                        if (Array.isArray(el.content)) {
                                            el.content.forEach(function (subSubEl) {
                                                if (Array.isArray(subSubEl.content)) {
                                                    subSubEl.content.forEach(function (subSubSubEl) {
                                                        if (subSubSubEl.mandatory) {
                                                            _this.totMandatoryDocs++;
                                                            if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                                subEl.mandatory++;
                                                                _this.totInsertDocs++;
                                                            }
                                                        }
                                                        if (subSubSubEl.mandatory && !_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                            subEl.notInsert++;
                                                            _this.totNotInsertDocs++;
                                                        }
                                                        if (!subSubSubEl.mandatory) {
                                                            subEl.optional++;
                                                            _this.totOptionalDocs++;
                                                        }
                                                        if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                            inserted_1 += 1;
                                                        }
                                                    });
                                                }
                                                else {
                                                    if (subSubEl.mandatory) {
                                                        _this.totMandatoryDocs++;
                                                        if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                            subEl.mandatory++;
                                                            _this.totInsertDocs++;
                                                        }
                                                    }
                                                    if (subSubEl.mandatory && !_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                        subEl.notInsert++;
                                                        _this.totNotInsertDocs++;
                                                    }
                                                    if (!subSubEl.mandatory) {
                                                        subEl.optional++;
                                                        _this.totOptionalDocs++;
                                                    }
                                                    if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                        inserted_1 += 1;
                                                    }
                                                }
                                            });
                                        }
                                        if ((inserted_1 === 0 &&
                                            _this.currentRole.propertiesPermission.docsInserted) ||
                                            (inserted_1 === 0 &&
                                                subEl.notInsert === 0 &&
                                                !_this.currentRole.propertiesPermission.docsInserted)) {
                                            subEl.visible = false;
                                        }
                                    }
                                });
                            });
                            return "break";
                        }
                    };
                    for (var key in _this.documentsStructure) {
                        var state_1 = _loop_3(key);
                        if (state_1 === "break")
                            break;
                    }
                }
                else if (title === "properties.documents.unitaImmobiliari" &&
                    _this.filterMenuItem(title)) {
                    var _loop_4 = function (key) {
                        if (_this.documentsStructure[key].title === title) {
                            _this.documentsStructure[key].content.length = 0;
                            _this.documentsStructure[key].visible = true;
                            levels.forEach(function (el) {
                                var subEl = {
                                    title: el.title,
                                    type: "link",
                                    section: "string",
                                    key: "",
                                    visible: true,
                                    notInsert: 0,
                                    mandatory: 0,
                                    optional: 0,
                                };
                                var inserted = 0;
                                if (Array.isArray(el.content)) {
                                    el.content.forEach(function (subSubEl) {
                                        if (Array.isArray(subSubEl.content)) {
                                            subSubEl.content.forEach(function (subSubSubEl) {
                                                if (subSubSubEl.mandatory) {
                                                    _this.totMandatoryDocs++;
                                                    if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                        subEl.mandatory++;
                                                        _this.totInsertDocs++;
                                                    }
                                                }
                                                if (subSubSubEl.mandatory && !_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                    subEl.notInsert++;
                                                    _this.totNotInsertDocs++;
                                                }
                                                if (!subSubSubEl.mandatory) {
                                                    subEl.optional++;
                                                    _this.totOptionalDocs++;
                                                }
                                                if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                    inserted += 1;
                                                }
                                            });
                                        }
                                        else {
                                            if (subSubEl.mandatory) {
                                                _this.totMandatoryDocs++;
                                                if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                    subEl.mandatory++;
                                                    _this.totInsertDocs++;
                                                }
                                            }
                                            if (subSubEl.mandatory && !_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                subEl.notInsert++;
                                                _this.totNotInsertDocs++;
                                            }
                                            if (!subSubEl.mandatory) {
                                                subEl.optional++;
                                                _this.totOptionalDocs++;
                                            }
                                            if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                inserted += 1;
                                            }
                                        }
                                    });
                                }
                                if ((inserted === 0 &&
                                    _this.currentRole.propertiesPermission.docsInserted) ||
                                    (inserted === 0 &&
                                        subEl.notInsert === 0 &&
                                        !_this.currentRole.propertiesPermission.docsInserted)) {
                                    subEl.visible = false;
                                }
                                _this.documentsStructure[key].content.push(subEl);
                            });
                            return "break";
                        }
                    };
                    for (var key in _this.documentsStructure) {
                        var state_2 = _loop_4(key);
                        if (state_2 === "break")
                            break;
                    }
                }
                else if (title === "properties.documents.attivitaSottopostePrevenzioneIncendi" &&
                    _this.filterMenuItem(title)) {
                    var _loop_5 = function (key) {
                        if (_this.documentsStructure[key].title === title) {
                            _this.documentsStructure[key].content.length = 0;
                            _this.documentsStructure[key].visible = true;
                            if (Array.isArray(levels[0].content)) {
                                levels[0].content.forEach(function (el) {
                                    var subEl = {
                                        title: el.title,
                                        type: "link",
                                        section: "string",
                                        key: "",
                                        visible: true,
                                        notInsert: 0,
                                        mandatory: 0,
                                        optional: 0,
                                    };
                                    var inserted = 0;
                                    if (Array.isArray(el.content)) {
                                        el.content.forEach(function (subSubEl) {
                                            if (Array.isArray(subSubEl.content)) {
                                                subSubEl.content.forEach(function (subSubSubEl) {
                                                    if (subSubSubEl.mandatory) {
                                                        _this.totMandatoryDocs++;
                                                        if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                            subEl.mandatory++;
                                                            _this.totInsertDocs++;
                                                        }
                                                    }
                                                    if (subSubSubEl.mandatory && !_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                        subEl.notInsert++;
                                                        _this.totNotInsertDocs++;
                                                    }
                                                    if (!subSubSubEl.mandatory) {
                                                        subEl.optional++;
                                                        _this.totOptionalDocs++;
                                                    }
                                                    if (_this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                                        inserted += 1;
                                                    }
                                                });
                                            }
                                            else {
                                                if (subSubEl.mandatory) {
                                                    _this.totMandatoryDocs++;
                                                    if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                        subEl.mandatory++;
                                                        _this.totInsertDocs++;
                                                    }
                                                }
                                                if (subSubEl.mandatory && !_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                    subEl.notInsert++;
                                                    _this.totNotInsertDocs++;
                                                }
                                                if (!subSubEl.mandatory) {
                                                    subEl.optional++;
                                                    _this.totOptionalDocs++;
                                                }
                                                if (_this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                                                    inserted += 1;
                                                }
                                            }
                                        });
                                    }
                                    if ((inserted === 0 &&
                                        _this.currentRole.propertiesPermission.docsInserted) ||
                                        (inserted === 0 &&
                                            subEl.notInsert === 0 &&
                                            !_this.currentRole.propertiesPermission.docsInserted)) {
                                        subEl.visible = false;
                                    }
                                    _this.documentsStructure[key].content.push(subEl);
                                });
                            }
                            return "break";
                        }
                    };
                    for (var key in _this.documentsStructure) {
                        var state_3 = _loop_5(key);
                        if (state_3 === "break")
                            break;
                    }
                }
            });
        }
        this.documentsStructure.forEach(function (el) {
            if (el.visible) {
                if (el.content &&
                    Array.isArray(el.content) &&
                    el.content.length) {
                    el.visible = el.content.some(function (subEl) {
                        return subEl.visible;
                    });
                }
                else {
                    el.visible = false;
                }
            }
        });
        // this.progressBarVal = 0;
        // if ((this.totInsertDocs + this.totNotInsertDocs) > 0) {
        //   this.progressBarVal = Math.trunc((this.totInsertDocs / (this.totInsertDocs + this.totNotInsertDocs)) * 100);
        // }
        // this.progressBarValStyle = { 'width': `${this.progressBarVal}%` };
        this.totDocs = this.totOptionalDocs + this.totInsertDocs;
    };
    ViewPropertyComponent.prototype.filterMenuItem = function (title) {
        if ((title === "properties.documents.gestionaleAmministrativo" &&
            !this.currentRole.propertiesPermission.gestionaleAmministrativo)
            ||
                (title === "properties.documents.verbaliconvocazioni" &&
                    !this.currentRole.propertiesPermission.gestionaleContabile)
            ||
                (title === "properties.documents.urbanisticaEdEdilizia" &&
                    !this.currentRole.propertiesPermission.urbanisticaEdEdilizia)
            ||
                (title === "properties.documents.catasto" &&
                    !this.currentRole.propertiesPermission.catasto)
            ||
                (title === "properties.documents.contratti" &&
                    !this.currentRole.propertiesPermission.contratti)
            ||
                (title === "properties.documents.lineaVita" &&
                    !this.currentRole.propertiesPermission.lineaVita)
            ||
                (title === "properties.documents.amiantoDoc" &&
                    !this.currentRole.propertiesPermission.amiantoDoc)
            ||
                (title === "properties.documents.edile" &&
                    !this.currentRole.propertiesPermission.edile)
            ||
                (title === "properties.documents.impiantoElettrico" &&
                    !this.currentRole.propertiesPermission.impiantoElettrico)
            ||
                (title === "properties.documents.riscaldamentoCondizionamento" &&
                    !this.currentRole.propertiesPermission.riscaldamentoCondizionamento)
            ||
                (title === "properties.documents.ascensoriEMontauto" &&
                    !this.currentRole.propertiesPermission.ascensori)
            ||
                (title === "properties.documents.trattamentoAcqua" &&
                    !this.currentRole.propertiesPermission.trattamentoAcqua)
            ||
                (title === "properties.documents.impiantiElettronici" &&
                    !this.currentRole.propertiesPermission.impiantiElettronici)
            ||
                ((title === "properties.documents.impiantiAntincendio" ||
                    title === "properties.documents.attivitaSottopostePrevenzioneIncendi") &&
                    !this.currentRole.propertiesPermission.antincendio)
            ||
                (title === "properties.documents.impiantiSpeciali" &&
                    !this.currentRole.propertiesPermission.impiantiSpeciali)
            ||
                (title === "properties.documents.impiantiRicreativiSportivi" &&
                    !this.currentRole.propertiesPermission.impiantiRicreativiSportivi)
            ||
                (title === "properties.documents.unitaImmobiliari" &&
                    !this.currentRole.propertiesPermission.unitaImmobiliari)) {
            return false;
        }
        return true;
    };
    ViewPropertyComponent.prototype.filterDisplayedDocs = function (docs) {
        var _this = this;
        if ((docs.keyTranslateTitle === "properties.documents.gestionaleAmministrativo" &&
            !this.currentRole.propertiesPermission.gestionaleAmministrativo)
            ||
                (docs.keyTranslateTitle === "properties.documents.R5gestionali" &&
                    !this.currentRole.propertiesPermission.gestionaleContabile)
            ||
                (docs.keyTranslateTitle === "properties.documents.urbanisticaEdEdilizia" &&
                    !this.currentRole.propertiesPermission.urbanisticaEdEdilizia)
            ||
                (docs.keyTranslateTitle === "properties.documents.catasto" &&
                    !this.currentRole.propertiesPermission.catasto)
            ||
                (docs.keyTranslateTitle === "properties.documents.contratti" &&
                    !this.currentRole.propertiesPermission.contratti)
            ||
                (docs.keyTranslateTitle === "properties.documents.lineaVita" &&
                    !this.currentRole.propertiesPermission.lineaVita)
            ||
                (docs.keyTranslateTitle === "properties.documents.amiantoDoc" &&
                    !this.currentRole.propertiesPermission.amiantoDoc)
            ||
                (docs.keyTranslateTitle === "properties.documents.edile" &&
                    !this.currentRole.propertiesPermission.edile)
            ||
                (docs.keyTranslateTitle === "properties.documents.impiantoElettrico" &&
                    !this.currentRole.propertiesPermission.impiantoElettrico)
            ||
                (docs.keyTranslateTitle === "properties.documents.riscaldamentoCondizionamento" &&
                    !this.currentRole.propertiesPermission.riscaldamentoCondizionamento)
            ||
                (docs.keyTranslateTitle === "properties.documents.ascensoriEMontauto" &&
                    !this.currentRole.propertiesPermission.ascensori)
            ||
                (docs.keyTranslateTitle === "properties.documents.trattamentoAcqua" &&
                    !this.currentRole.propertiesPermission.trattamentoAcqua)
            ||
                (docs.keyTranslateTitle === "properties.documents.impiantiElettronici" &&
                    !this.currentRole.propertiesPermission.impiantiElettronici)
            ||
                ((docs.keyTranslateTitle === "properties.documents.impiantiAntincendio" ||
                    docs.keyTranslateTitle === "properties.documents.attivitaSottopostePrevenzioneIncendi") &&
                    !this.currentRole.propertiesPermission.antincendio)
            ||
                (docs.keyTranslateTitle === "properties.documents.impiantiSpeciali" &&
                    !this.currentRole.propertiesPermission.impiantiSpeciali)
            ||
                (docs.keyTranslateTitle === "properties.documents.impiantiRicreativiSportivi" &&
                    !this.currentRole.propertiesPermission.impiantiRicreativiSportivi)
            ||
                (docs.keyTranslateTitle === "properties.documents.unitaImmobiliari" &&
                    !this.currentRole.propertiesPermission.unitaImmobiliari)) {
            return "";
        }
        if (typeof docs.contract !== 'undefined' &&
            docs.contract &&
            !this.currentRole.propertiesPermission.contratti) {
            return "";
        }
        // if (this.currentRole.propertiesPermission.gestionaleAmministrativo)
        if (docs.content && Array.isArray(docs.content) && docs.content.length) {
            var values = {};
            var contents = this.filterDisplayedDocs(docs.content);
            if (contents && Array.isArray(contents) && contents.length) {
                values = {
                    content: contents,
                    docId: docs.docId,
                    structureId: docs.structureId,
                    title: docs.title,
                    type: docs.type
                };
            }
            return values;
        }
        else {
            if (docs && Array.isArray(docs) && docs.length) {
                var content_1 = [];
                docs.forEach(function (docs) {
                    var ret = _this.filterDisplayedDocs(docs);
                    if (!(Object.keys(ret).length === 0 && ret.constructor === Object) && ret !== "") {
                        content_1.push(ret);
                    }
                });
                return content_1;
            }
            else {
                var found = false;
                if (typeof this.currentRole.propertiesPermission.docsInserted === "undefined" && docs.data) { // only inserted docs
                    found = true;
                }
                if (typeof this.currentRole.propertiesPermission.docsInserted !== "undefined"
                    && this.currentRole.propertiesPermission.docsInserted
                    && docs.data) { // only inserted docs
                    found = true;
                }
                else if (typeof this.currentRole.propertiesPermission.docsInserted !== "undefined"
                    && !this.currentRole.propertiesPermission.docsInserted) { // all docs
                    found = true;
                }
                if (found) {
                    return docs;
                }
            }
        }
        return "";
    };
    /**
     * Handle click on document form to download file
     * itemData: data value of form items
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.onToggleDownloadDocument = function (documents) {
        var _this = this;
        if (!documents || !documents.length) {
            console.warn("ERROR: NO DOCS");
            return;
        }
        var dialogRef = this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                propertyId: this.propertyId,
                documents: documents,
            },
            width: "600px"
        });
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                _this.documentArchiveIsLoading = true;
                // recreate view of all docs to show new inserted doc
                _this.allDocs = [];
                _this.getDocumentArchiveData2();
            }
        });
    };
    /**
     * Translate all keys with given labels inside given object and returns it
     *
     * @since 4.0.0
     */
    ViewPropertyComponent.prototype.translateKeys = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                for (var prop in item) {
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            item[prop] = _this.translateService.instant(item[prop]);
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys(keys, item[prop]);
                        }
                    }
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    ViewPropertyComponent.prototype.translateKeys2 = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                var _loop_6 = function (prop) {
                    if (prop === "hooks") {
                        var propKey_1 = item[prop];
                        item[prop] = {
                            onInit: function (field) {
                                field.defaultValue = propKey_1 + " " + (+field.parent.key + 1);
                            },
                        };
                    }
                    if (prop === "hideExpression" && item[prop]) {
                        var propKey_2 = item[prop].key;
                        var propCompareValue_1 = item[prop].value;
                        if (item[prop].operator === "!==") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return currentValue !== compareValue;
                            };
                        }
                        else if (item[prop].operator === "!") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                return !currentValue;
                            };
                        }
                        else if (item[prop].operator === "!includes") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return typeof currentValue === "undefined" || !currentValue.includes(compareValue);
                            };
                        }
                    }
                    if (prop === "expressionProperties" && item[prop]) {
                        var propDisabled = item[prop].disabled;
                        if (propDisabled !== "formState.disabled" &&
                            propDisabled !== "connessioni" &&
                            propDisabled !== "") {
                            var key_1 = propDisabled;
                            propDisabled = function (model, formState, field) {
                                return model[key_1];
                            };
                        }
                        else if (propDisabled === "connessioni") {
                            var key_2 = propDisabled;
                            propDisabled = function (model, formState, field) {
                                if (model[key_2] === "undefined") {
                                    return false;
                                }
                                else if (Array.isArray(model[key_2]) && model[key_2].length > 0) {
                                    return true;
                                }
                                return false;
                            };
                        }
                        if (typeof item[prop].required !== "undefined") {
                            var propKey_3 = item[prop].required.key;
                            var propCompareValue_2 = item[prop].required.value;
                            if (item[prop].required.operator === "===") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        var compareValue = propCompareValue_2;
                                        return currentValue === compareValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "!") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return !currentValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return currentValue;
                                    }
                                };
                            }
                        }
                        else {
                            item[prop] = {
                                "templateOptions.disabled": propDisabled,
                            };
                        }
                    }
                    if (prop === "defaultValue" && item[prop]) {
                        if (item[prop] === "false") {
                            item[prop] = false;
                        }
                        else if (item[prop] === "true") {
                            item[prop] = true;
                        }
                    }
                    if (prop === "wrappers" && item[prop] && Array.isArray(item[prop]) && item[prop].length === 0) {
                        item[prop] = "";
                    }
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            if (item["translation"]) {
                                item[prop] = item["translation"].it;
                            }
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys2(keys, item[prop]);
                        }
                    }
                };
                for (var prop in item) {
                    _loop_6(prop);
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (prop === "options" && Array.isArray(obj[prop])) {
                        obj[prop].forEach(function (elem) {
                            if (elem.value && elem.value === "true") {
                                elem.value = true;
                            }
                            else if (elem.value && elem.value === "false") {
                                elem.value = false;
                            }
                        });
                    }
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                        if (prop === "label" && obj["translationLabel"]) {
                            obj[prop] = obj["translationLabel"].it;
                        }
                        else if (prop === "placeholder" && obj["translationPlaceholder"]) {
                            obj[prop] = obj["translationPlaceholder"].it;
                        }
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys2(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    /**
     * Check if given macr-section item is visibile or not depending on
     * structure open status. If structure is open, than this will always returns true
     * If it's false, this will check if at least one sub-section has one or more
     * values. If so, return true, otherwise return false;
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.checkVisibility = function (item) {
        var _this = this;
        // // "Impianti speciali" and "Attività prev. incendi" are visible only Archedi users
        // if (
        //   (item.title === "properties.structures.attivitaPrevenzioneIncendi" ||
        //     item.title === "properties.structures.impiantiSpeciali") &&
        //   this.currentRole && (this.currentRole.type !== "admin" &&
        //     this.currentRole.type !== "operator")
        // ) {
        //   return false;
        // }
        var condoStructureClose = true;
        if (condoStructureClose) {
            if (item.content && item.content.length) {
                // Let's make anagrafica section ALWAYS visible
                if (item.content[0].key === "anagrafica") {
                    return true;
                }
                return item.content.some(function (subitem) { return _this.getChildren(subitem.key).length; });
            }
            return false;
        }
        return true;
    };
    /**
     * Navigate to given section inside the same property detail page
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.activateSection = function (rawSection) {
        var top = document.getElementById("structure-card").offsetTop;
        window.scrollTo({
            top: top,
            behavior: "smooth"
        });
        // Reset data and call the new data form
        this.formActiveSubitemId = undefined;
        var controls = this.form.controls;
        for (var key in controls) {
            this.form.removeControl(key);
        }
        var section = rawSection.replace(":structureId", this.propertyData.structure);
        this.formActiveSubitemId = "";
        this.formActiveSection = section;
        this.updateFormSection();
    };
    /**
     * Handle form item click and open view/edit popup
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.onFormItemClick = function (rawSection, item) {
        var top = document.getElementById("structure-card").offsetTop;
        window.scrollTo({
            top: top,
            behavior: "smooth"
        });
        var section = rawSection.replace(":structureId", this.propertyData.structure);
        this.formActiveSubitemId = item._id;
        this.formActiveSection = section;
        this.updateFormSection();
    };
    /**
     * Update form section depending on route params
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.updateFormSection = function () {
        var _this = this;
        // Reset model to prevent import previous form data
        if (this.model) {
            for (var property in this.model) {
                delete this.model[property];
            }
        }
        var top = document.getElementById("structure-card").offsetTop;
        window.scrollTo({
            top: top,
            behavior: "smooth"
        });
        // Reset data and call the new data form
        if (this.form) {
            this.options.formState = {
                disabled: true
            };
        }
        // Add section param to routing, which is used in connections type
        var params = Object.assign({}, this.activatedRoute.snapshot.params, { selected: false });
        params.mappingFormActiveSection = this.formActiveSection;
        this.activatedRoute.snapshot.params = params;
        if (this.formActiveSection) {
            this.formIsLoading = true; // Start form loading
            //mappingFormActiveSection = decodeURIComponent(mappingFormActiveSection);
            // BEGIN - Set open status to current mapping index
            var origFormActiveSection_1 = this.formActiveSection.replace(this.propertyData.structure, ":structureId");
            this.mappingIndex.map(function (item) {
                item.content.map(function (subItem) {
                    if (subItem.section === origFormActiveSection_1) {
                        // Get currente element is a Plant
                        // delete note field from form
                        if (subItem.formConfig
                            && Array.isArray(subItem.formConfig)
                            && subItem.formConfig.length) {
                            if (subItem.formConfig[0].fieldGroup
                                && Array.isArray(subItem.formConfig[0].fieldGroup)
                                && subItem.formConfig[0].fieldGroup.length) {
                                var index = subItem.formConfig[0].fieldGroup.findIndex(function (el) {
                                    return el.key === "note";
                                });
                                if (index > -1) {
                                    subItem.formConfig[0].fieldGroup.splice(index, 1);
                                }
                            }
                        }
                        if (item.title === "properties.structures.impiantiElettrici" ||
                            item.title === "properties.structures.trattamentoAcqua" ||
                            item.title ===
                                "properties.structures.riscaldamentoCondizionamento" ||
                            item.title === "properties.structures.dispositiviAntincendio" ||
                            item.title === "properties.structures.ascensoriEMontauto" ||
                            item.title === "properties.structures.impiantiElettronici" ||
                            item.title === "properties.structures.lineeVita" ||
                            item.title === "properties.structures.impiantiSpeciali" ||
                            item.title === "properties.structures.impiantiRicreativi") {
                            _this.sectionPlant = true;
                        }
                        else {
                            _this.sectionPlant = false;
                        }
                        item.expanded = true;
                        subItem.active = true;
                        _this.activeItem = subItem;
                        if (_this.formActiveSection &&
                            origFormActiveSection_1 !==
                                "condo-structures/:structureId/anagrafica") {
                            var children = _this.getChildren(subItem.key);
                            if (children.length) {
                                _this.activeSubitem = children.find(function (val) { return val._id === _this.formActiveSubitemId; });
                                if (_this.activeSubitem && _this.activeSubitem.files) {
                                    if (_this.form.controls.files) {
                                        _this.form.controls.files.setValue(_this.activeSubitem.files);
                                    }
                                    _this.form.updateValueAndValidity();
                                }
                                _this.fields = subItem.formConfig;
                                if (_this.activeSubitem) {
                                    _this.model = _this.activeSubitem;
                                }
                                else {
                                    // Add new subitem. Default name from section
                                    var tot = children.length + 1;
                                    var nome = _this.translateService.instant(subItem.title) + " " + tot;
                                    _this.model = { nome: nome };
                                }
                            }
                            else {
                                // New first subitem. Default name from section
                                _this.fields = subItem.formConfig;
                                var nome = _this.translateService.instant(subItem.title) + " 1";
                                _this.model = { nome: nome };
                            }
                        }
                        else if (subItem.section === "condo-structures/:structureId/anagrafica") {
                            _this.activeSubitem = _this.condoStructure.anagrafica;
                            // Anagrafica: is not completed
                            if (typeof _this.activeSubitem === "undefined") {
                                _this.activeSubitem = {
                                    active: true
                                };
                            }
                            _this.fields = subItem.formConfig;
                            _this.model = _this.activeSubitem;
                            _this.formActiveSubitemId = Math.random().toString();
                        }
                    }
                    else {
                        // item.expanded = false;
                        subItem.active = false;
                    }
                });
            });
            if (this.form && !this.condoStructure.open) {
                this.options.formState = {
                    disabled: true
                };
            }
            // END - Set open status to current mapping index
            this.formIsLoading = false;
        }
        else {
            // Reset the last item.expanded mappingIndex to close tree from previous structure
            if (Array.isArray(this.mappingIndex) && this.mappingIndex.length) {
                this.mappingIndex.forEach(function (item) {
                    if (item.expanded) {
                        item.expanded = false;
                        if (Array.isArray(item.content) && item.content.length) {
                            item.content.forEach(function (elem) {
                                if (elem.active) {
                                    elem.active = false;
                                }
                            });
                        }
                    }
                });
            }
        }
    };
    /**
     * Get children (existing values) for requested section
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.getChildren = function (key) {
        if (typeof this.condoStructure !== "undefined"
            && typeof this.condoStructure[key] !== "undefined") {
            if (key === "anagrafica") {
                return [];
            }
            else {
                if (Array.isArray(this.condoStructure[key])) {
                    var structures = JSON.parse(JSON.stringify(this.condoStructure[key]));
                    structures = structures.filter(function (el) { return el.active; });
                    return structures;
                }
                else {
                    return [];
                }
            }
        }
        return [];
    };
    /**
     * Handle panel header open/close
     *
     * @since 1.0.0
     *
     */
    ViewPropertyComponent.prototype.onPanelClicked = function (item, index) {
        item.expanded = !item.expanded;
        this.mappingIndex.forEach(function (el, i) {
            if (i !== index) {
                el.expanded = false;
            }
        });
        // Handle scroll to panel
        if (item.expanded) {
            var offset = 400;
            var headerHeight = 60;
            var top_1 = (headerHeight * (index + 1)) - headerHeight + offset;
            window.scrollTo({
                top: top_1,
                behavior: "smooth"
            });
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
      * Handle table sort
      *
      * @since 1.0.0
      */
    ViewPropertyComponent.prototype.sortData = function (sort, i, t, x, pos) {
        var _this = this;
        var sortedData = [];
        if (pos === '1') {
            sortedData = this.displayedDocs[i].content[t].content[x].content;
        }
        else if (pos === '2') {
            sortedData = this.displayedDocs[i].content[t].content;
        }
        else if (pos === '3') {
            sortedData = this.displayedDocs[i].content;
        }
        var data = sortedData;
        if (!sort.active || sort.direction === '') {
            sortedData = data;
            if (pos === '1') {
                this.displayedDocs[i].content[t].content[x].content = sortedData;
            }
            else if (pos === '2') {
                this.displayedDocs[i].content[t].content = sortedData;
            }
            else if (pos === '3') {
                this.displayedDocs[i].content = sortedData;
            }
            return;
        }
        sortedData = data.sort(function (a, b) {
            var isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'title':
                    return _this.compare(a.title.toLowerCase(), b.title.toLowerCase(), isAsc);
                case 'data.contenutoDocumento':
                    var aContenutoDocumento = (a.data && a.data.contenutoDocumento) ? a.data.contenutoDocumento.toLowerCase() : "";
                    var bContenutoDocumento = (b.data && b.data.contenutoDocumento) ? b.data.contenutoDocumento.toLowerCase() : "";
                    return _this.compare(aContenutoDocumento, bContenutoDocumento, isAsc);
                case 'data.ragioneSocialeFornitore':
                    var aRagioneSocialeFornitore = (a.data && a.data.ragioneSocialeFornitore) ? a.data.ragioneSocialeFornitore : "";
                    var bRagioneSocialeFornitore = (b.data && b.data.ragioneSocialeFornitore) ? b.data.ragioneSocialeFornitore : "";
                    return _this.compare(aRagioneSocialeFornitore, bRagioneSocialeFornitore, isAsc);
                case 'data.dataDocumento':
                    var aDataDocumento = (a.data && a.data.dataDocumento) ? a.data.dataDocumento : "";
                    var bDataDocumento = (b.data && b.data.dataDocumento) ? b.data.dataDocumento : "";
                    return _this.compare(aDataDocumento, bDataDocumento, isAsc);
                case 'dateExpired':
                    var aDateExpired = (a.dateExpired) ? a.dateExpired : "";
                    var bDateExpired = (b.dateExpired) ? b.dateExpired : "";
                    return _this.compare(aDateExpired, bDateExpired, isAsc);
                default: return 0;
            }
        });
        if (pos === '1') {
            this.displayedDocs[i].content[t].content[x].content = sortedData;
        }
        else if (pos === '2') {
            this.displayedDocs[i].content[t].content = sortedData;
        }
        else if (pos === '3') {
            this.displayedDocs[i].content = sortedData;
        }
    };
    /**
     * Utility per table sort
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.compare = function (a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    /**
   * Handle side menu to expand panel
   *
   * @since 1.0.0
   */
    ViewPropertyComponent.prototype.onItemOpen = function (item) {
        item.expanded = true;
        this.documentsStructure.forEach(function (el) {
            if (el.title !== item.title
                && el.expanded) {
                el.expanded = false;
            }
        });
    };
    /**
     * Handle side menu to close panel
     *
     * @since 1.0.0
     */
    ViewPropertyComponent.prototype.onItemClose = function (item) {
        item.expanded = false;
    };
    /**
   * Handle scroll to selected title
   *
   * @since 1.0.0
   */
    ViewPropertyComponent.prototype.onTitleClicked = function (rawTitle) {
        var _this = this;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setTimeout(function () {
            var title = _this.translateService.instant(rawTitle);
            var docsWindow = document.getElementById("doc-wrapper");
            var target = document.getElementById(title);
            var top = target.offsetTop;
            docsWindow.scrollTo({
                top: top,
                behavior: "smooth"
            });
        }, 500);
    };
    return ViewPropertyComponent;
}());
export { ViewPropertyComponent };
